var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g3, _g4, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _g5, _g6, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 825,
    height: 1296,
    viewBox: "0 0 825 1296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1159.49 1505.52L1040.36 1460.82L914.115 1513.64L829.28 1481.2L789.994 1370.79L514.46 1266.58L417.421 1307.18L326.769 1272.9L324.205 1277.3L417.243 1312.48L514.282 1271.88L785.641 1374.51L824.927 1484.92L913.789 1518.53L1040.03 1465.71L1157.07 1510.33L1159.49 1505.52Z",
    fill: "url(#paint0_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.677 1197.9L365 1126.13L314.786 1147.15L177.224 1095.1L175.224 1099.8L314.455 1152.12L364.669 1131.1L550.711 1201.49L607.075 1359.96L780.996 1425.77L820.167 1535.9L1030.91 1615.27L1084.31 1592.91L1119.01 1606.4L1121.61 1601.93L1084.65 1587.94L1031.24 1610.3L824.441 1531.69L785.42 1421.98L610.892 1355.95L554.677 1197.9Z",
    fill: "url(#paint1_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.22 1081.12L981.972 1053.98L867.274 1100.94L770.22 1065.02L446.263 1197.66L367.226 1168.41L365.165 1172.42L445.946 1202.32L769.903 1069.68L866.519 1105.78L981.655 1058.64L1053.86 1085.71L1056.22 1081.12Z",
    fill: "url(#paint2_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.63 1383.01L936.831 1340.69L868.913 1369.13L623.071 1276.07L618.957 1284.98L867.952 1379.6L935.87 1351.16L1040.46 1390.75L1068.63 1470.01L1167.81 1507.56L1172.53 1498.87L1076.81 1462.27L1048.63 1383.01Z",
    fill: "url(#paint3_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.341 1226.65L707.245 1158.56L705.238 1163.28L883.358 1230.26L910.52 1308.05L1105.22 1381.66L1123.08 1431.85L1198.38 1459.95L1200.53 1455.65L1127.52 1428.05L1109.66 1377.86L914.961 1304.25L887.341 1226.65Z",
    fill: "url(#paint4_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.04 1172.64L970.467 1142.9L717.447 1248.85L608.883 1207.76L569.225 1096.2L305.313 996.308L283.264 934.289L219.685 910.223L215.432 918.699L274.96 941.592L297.608 1003.84L561.52 1103.73L601.178 1215.29L716.94 1259.1L969.508 1153.34L1040.88 1180.36L1058.49 1229.89L1253.58 1304.09L1258.13 1295.01L1066.8 1222.59L1049.04 1172.64Z",
    fill: "url(#paint5_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.65 1160.97L653.44 1051.96L454.315 1135.28L300.961 1077.28L296.427 1086.31L453.361 1145.67L652.936 1062.16L933.535 1168.65L964.009 1254.3L1227.16 1353.83L1231.69 1344.8L972.123 1246.63L941.65 1160.97Z",
    fill: "url(#paint6_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.853 865.784L242.395 827.828L239.926 832.74L337.406 869.584L370.173 961.618L561.478 1033.92L564.097 1029.43L374.62 957.818L341.853 865.784Z",
    fill: "url(#paint7_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.79 1049.32L957.105 923.221L814.176 982.977L643.468 918.465L542.655 960.613L474.848 934.987L472.291 939.371L541.883 965.67L643.143 923.335L813.851 987.847L956.333 928.278L1287.04 1053.26L1316.54 1136.09L1337.95 1144.18L1339.91 1139.57L1320.43 1132.57L1290.79 1049.32Z",
    fill: "url(#paint8_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.68 896.766L1002.84 790.697L959.006 809.011L805.817 751.155L505.699 876.55L236.728 774.966L216.952 719.464L212.032 721.52L232.54 779.078L505.074 882.007L805.639 756.425L958.234 814.056L1002.07 795.742L1279.94 900.69L1290.64 930.702L1400.63 972.599L1403.04 967.815L1294.52 927.189L1283.68 896.766Z",
    fill: "url(#paint9_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.502 900.058L458.127 810.755L455.962 815.061L691.655 904.094L733.978 1024.38L1045.39 1142.02L1094.04 1278.61L1246.7 1336.27L1248.71 1331.54L1098.5 1274.8L1049.84 1138.21L738.435 1020.58L695.502 900.058Z",
    fill: "url(#paint10_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.663 1244.57C337.095 1239.72 335.171 1234.31 330.37 1232.49C325.569 1230.67 319.693 1233.13 317.261 1237.98C314.829 1242.82 316.754 1248.24 321.554 1250.06C326.355 1251.87 332.232 1249.41 334.663 1244.57Z",
    fill: "url(#paint11_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.369 1152.22C379.8 1147.37 377.876 1141.96 373.075 1140.14C368.275 1138.32 362.398 1140.78 359.966 1145.63C357.534 1150.48 359.459 1155.89 364.259 1157.71C369.06 1159.52 374.937 1157.06 377.821 1152.03L377.369 1152.22Z",
    fill: "url(#paint12_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.343 821.571C253.777 816.72 251.851 811.301 247.046 809.483C242.241 807.664 236.359 810.127 233.925 814.977C231.491 819.828 233.417 825.247 238.371 827.483C243.176 829.302 249.057 826.839 251.491 821.988L251.343 821.571Z",
    fill: "url(#paint13_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.769 1047.62C574.203 1042.77 572.277 1037.35 567.472 1035.53C562.667 1033.72 556.785 1036.18 554.351 1041.03C551.917 1045.88 553.843 1051.3 558.796 1053.53C563.601 1055.35 569.483 1052.89 571.917 1048.04L571.769 1047.62Z",
    fill: "url(#paint14_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.607 907.882C486.039 903.036 484.114 897.623 479.313 895.805C474.513 893.988 468.636 896.449 466.204 901.295C463.772 906.141 465.697 911.555 470.498 913.372C475.298 915.189 481.175 912.728 483.607 907.882Z",
    fill: "url(#paint15_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.613 862.028C525.047 857.178 523.121 851.759 518.316 849.94C513.511 848.121 507.629 850.584 505.195 855.435C502.76 860.285 504.687 865.704 509.64 867.94C514.445 869.759 520.327 867.296 522.761 862.445L522.613 862.028Z",
    fill: "url(#paint16_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.591 1251.91C522.023 1247.07 520.099 1241.65 515.298 1239.84C510.497 1238.02 504.621 1240.48 502.189 1245.33C499.757 1250.17 501.681 1255.59 506.482 1257.4C511.283 1259.22 517.159 1256.76 519.591 1251.91Z",
    fill: "url(#paint17_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.091 1146.37C717.523 1141.52 715.599 1136.11 710.798 1134.29C705.997 1132.47 700.121 1134.94 697.689 1139.78C695.257 1144.63 697.181 1150.04 701.982 1151.86C706.783 1153.68 712.659 1151.21 715.091 1146.37Z",
    fill: "url(#paint18_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.308 981.005C823.74 976.159 821.815 970.746 817.015 968.928C812.214 967.111 806.337 969.572 803.906 974.418C801.474 979.264 803.398 984.678 808.199 986.495C813 988.312 818.876 985.851 821.308 981.005Z",
    fill: "url(#paint19_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.473 675.594C223.902 670.754 221.98 665.347 217.185 663.533C212.391 661.718 206.521 664.176 203.641 669.204C200.761 674.233 203.134 679.45 207.929 681.265C212.724 683.08 218.593 680.622 221.022 675.783L221.473 675.594Z",
    fill: "url(#paint20_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.822 786.78C469.253 781.934 467.329 776.52 462.528 774.703C457.727 772.886 451.851 775.346 449.419 780.192C446.987 785.038 448.912 790.452 453.713 792.269C458.513 794.087 464.39 791.626 466.822 786.78Z",
    fill: "url(#paint21_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.819 1016.72C749.248 1011.88 747.325 1006.47 742.529 1004.66C737.733 1002.84 731.861 1005.3 728.98 1010.33C726.55 1015.17 728.473 1020.58 733.27 1022.39C738.066 1024.21 743.937 1021.75 746.367 1016.91L746.819 1016.72Z",
    fill: "url(#paint22_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.402 1064.3C189.834 1059.45 187.909 1054.04 183.108 1052.22C178.308 1050.41 172.431 1052.87 169.999 1057.71C167.567 1062.56 169.492 1067.97 174.293 1069.79C179.093 1071.61 184.97 1069.15 187.402 1064.3Z",
    fill: "url(#paint23_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.783 1050.06C315.43 1042.8 312.766 1035.3 305.566 1032.58C298.367 1029.85 290.232 1033.26 286.585 1040.53C282.938 1047.79 285.603 1055.29 292.802 1058.01C300.001 1060.74 307.988 1056.91 311.783 1050.06Z",
    fill: "url(#paint24_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.577 1263.07C637.924 1256.4 635.108 1248.48 628.353 1245.57C621.597 1242.65 613 1246.25 609.349 1253.52C606.002 1260.19 608.818 1268.12 615.573 1271.03C622.328 1273.95 630.925 1270.35 634.124 1263.26L634.577 1263.07Z",
    fill: "url(#paint25_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.046 875.888C232.698 868.61 229.578 861.295 222.821 858.376C216.064 855.458 207.466 859.058 204.267 866.146C200.919 872.817 203.735 880.739 210.492 883.658C217.1 886.159 225.847 882.976 229.499 875.698L229.046 875.888Z",
    fill: "url(#paint26_linear_78_4792)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.138 1371.35L668.151 1351.29L666.626 1354.33L718.408 1373.93L739.338 1435.74L836.429 1472.86L845.491 1498.35L929.788 1530.26L1004.63 1498.92L1003.59 1495.99L930.563 1526.57L848.674 1495.57L839.464 1469.67L742.521 1432.97L721.138 1371.35Z",
    fill: "url(#paint27_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.85 1401.45L949.724 1368.48L856.725 1407.39L793.504 1383.48L764.517 1302.02L560.992 1224.69L489.108 1254.76L421.713 1229.27L420.35 1232.7L488.937 1258.64L560.372 1228.75L761.365 1304.76L790.499 1386.64L856.105 1411.45L949.554 1372.36L1036.03 1405.06L1037.85 1401.45Z",
    fill: "url(#paint28_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.763 1174.2L450.171 1121L413.194 1136.48L311.535 1098.38L310 1101.44L413.021 1140.42L449.997 1124.94L587.56 1176.99L629.123 1293.84L758.202 1342.68L787.057 1423.81L942.8 1482.74L982.058 1466.3L1008.12 1476.16L1009.65 1473.11L982.232 1462.37L943.123 1479.22L789.804 1421.21L761.256 1339.47L632.327 1291.06L590.763 1174.2Z",
    fill: "url(#paint29_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.472 1087.76L906.408 1067.72L821.34 1102.1L749.861 1075.65L510.407 1173.67L451.856 1152.35L450.385 1155.22L510.241 1177.36L749.695 1079.34L821.173 1105.79L906.099 1071.02L959.562 1090.81L961.472 1087.76Z",
    fill: "url(#paint30_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.915 1310.99L872.972 1279.59L822.716 1300.64L641.204 1231.93L637.855 1238.6L822.372 1308.45L872.628 1287.4L949.708 1316.94L970.468 1375.34L1044.25 1402.91L1047.74 1396.65L976.822 1369.81L955.915 1310.99Z",
    fill: "url(#paint31_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.604 1195.23L703.517 1145.28L701.976 1148.35L833.388 1198.03L853.801 1255.39L997.989 1309.9L1011.2 1347.01L1066.56 1367.94L1068.56 1364.68L1013.96 1344.4L1000.75 1307.29L857.017 1252.59L836.604 1195.23Z",
    fill: "url(#paint32_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.287 1155.35L898.107 1133.33L711.057 1211.66L630.833 1181.65L601.386 1098.82L406.455 1025.04L390.03 978.839L342.795 961.32L339.453 967.98L383.689 984.363L400.114 1030.56L595.497 1104.16L624.944 1186.99L710.713 1219.45L897.312 1141.32L949.945 1160.88L963.115 1197.92L1107.66 1252.64L1111.01 1245.98L969.456 1192.4L956.287 1155.35Z",
    fill: "url(#paint33_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.706 1146.86L663.684 1066.28L516.253 1127.97L402.88 1085.09L399.555 1091.71L515.764 1135.31L663.196 1073.62L870.847 1152.16L893.518 1215.88L1088.04 1289.46L1091.37 1282.84L899.229 1210.16L876.706 1146.86Z",
    fill: "url(#paint34_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.273 928.301L359.557 900.438L357.705 904.123L430.053 931.102L454.402 999.492L595.743 1052.91L597.594 1049.23L457.472 996.269L433.273 928.301Z",
    fill: "url(#paint35_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.19 1064.42L888.205 970.729L782.465 1014.94L656.369 967.284L581.545 998.567L531.582 979.685L529.628 982.87L581.374 1002.43L656.199 971.143L782.295 1018.8L887.586 974.775L1132.05 1067.16L1153.76 1128.15L1169.82 1134.22L1171.18 1130.81L1156.91 1125.41L1135.19 1064.42Z",
    fill: "url(#paint36_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.81 951.515L921.848 872.618L889.644 886.073L776.384 843.653L554.092 936.531L355.184 861.408L340.536 820.296L337.405 821.604L352.493 863.95L553.922 940.381L776.214 847.503L889.027 890.11L921.678 876.467L1127.12 954.057L1135.03 976.257L1216.37 1006.98L1217.87 1003.99L1137.72 973.716L1129.81 951.515Z",
    fill: "url(#paint37_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.909 953.993L519.053 887.564L517.657 891.062L691.681 956.799L723.317 1045.6L953.517 1132.56L989.521 1233.63L1102.02 1276.49L1103.88 1272.8L992.749 1230.82L956.745 1129.76L726.545 1042.8L694.909 953.993Z",
    fill: "url(#paint38_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.698 1208.45C429.522 1204.82 428.041 1200.66 424.441 1199.29C420.84 1197.93 416.32 1199.82 414.496 1203.46C412.672 1207.09 414.152 1211.26 417.753 1212.62C421.353 1213.98 425.874 1212.09 427.698 1208.45Z",
    fill: "url(#paint39_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.446 1140.06C461.27 1136.43 459.789 1132.26 456.189 1130.9C452.588 1129.54 448.068 1131.43 446.244 1135.06C444.42 1138.7 445.9 1142.86 449.501 1144.23C453.101 1145.59 457.622 1143.7 459.446 1140.06Z",
    fill: "url(#paint40_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.405 895.92C368.228 892.286 366.748 888.121 363.147 886.758C359.547 885.395 355.027 887.288 353.203 890.923C351.379 894.557 352.859 898.722 356.46 900.085C360.06 901.447 364.581 899.555 366.405 895.92Z",
    fill: "url(#paint41_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.297 1062.98C605.121 1059.35 603.641 1055.18 600.04 1053.82C596.44 1052.46 591.919 1054.35 590.095 1057.98C588.271 1061.62 589.752 1065.78 593.352 1067.15C596.953 1068.51 601.473 1066.62 603.297 1062.98Z",
    fill: "url(#paint42_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.067 959.494C539.89 955.86 538.41 951.695 534.81 950.332C531.209 948.97 526.689 950.863 524.865 954.497C523.041 958.131 524.521 962.296 528.122 963.659C531.722 965.022 536.243 963.129 538.067 959.494Z",
    fill: "url(#paint43_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.899 925.629C568.723 921.995 567.242 917.83 563.642 916.467C560.041 915.104 555.521 916.997 553.697 920.632C551.873 924.266 553.353 928.431 556.954 929.794C560.554 931.157 565.075 929.264 566.899 925.629Z",
    fill: "url(#paint44_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.539 1113.18C827.363 1109.54 825.883 1105.38 822.282 1104.02C818.682 1102.65 814.161 1104.55 812.337 1108.18C810.514 1111.82 811.994 1115.98 815.595 1117.34C819.195 1118.71 823.715 1116.81 825.539 1113.18Z",
    fill: "url(#paint45_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.569 1214.03C566.393 1210.4 564.912 1206.24 561.312 1204.87C557.711 1203.51 553.191 1205.4 551.367 1209.04C549.543 1212.67 551.023 1216.84 554.624 1218.2C558.224 1219.56 562.745 1217.67 564.117 1214.22L564.569 1214.03Z",
    fill: "url(#paint46_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.11 1136.18C710.934 1132.55 709.453 1128.38 705.853 1127.02C702.252 1125.66 697.732 1127.55 695.908 1131.19C694.084 1134.82 695.564 1138.99 699.165 1140.35C702.765 1141.71 707.286 1139.82 709.11 1136.18Z",
    fill: "url(#paint47_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.018 1013.72C789.842 1010.08 788.361 1005.92 784.761 1004.55C781.16 1003.19 776.64 1005.08 774.816 1008.72C772.992 1012.35 774.473 1016.52 778.073 1017.88C781.674 1019.24 786.194 1017.35 788.018 1013.72Z",
    fill: "url(#paint48_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.182 787.538C346.006 783.903 344.525 779.739 340.925 778.376C337.324 777.013 332.804 778.906 330.98 782.54C329.156 786.175 330.637 790.339 334.237 791.702C337.838 793.065 342.358 791.172 344.182 787.538Z",
    fill: "url(#paint49_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.496 869.672C527.32 866.038 525.84 861.873 522.239 860.51C518.639 859.148 514.118 861.041 512.294 864.675C510.471 868.309 511.951 872.474 515.552 873.837C519.152 875.2 523.672 873.307 525.496 869.672Z",
    fill: "url(#paint50_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.6 1040.09C734.424 1036.45 732.943 1032.29 729.343 1030.93C725.742 1029.56 721.222 1031.46 719.398 1035.09C717.574 1038.73 719.055 1042.89 722.655 1044.25C726.256 1045.62 730.776 1043.72 732.6 1040.09Z",
    fill: "url(#paint51_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.528 1292.91C640.352 1289.27 638.871 1285.11 635.271 1283.74C631.67 1282.38 627.15 1284.27 625.326 1287.91C623.502 1291.54 624.982 1295.71 628.583 1297.07C632.183 1298.43 636.704 1296.54 638.528 1292.91Z",
    fill: "url(#paint52_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.998 1307.41C769.822 1303.77 768.342 1299.61 764.741 1298.24C761.141 1296.88 756.62 1298.77 754.796 1302.41C752.973 1306.04 754.453 1310.21 758.053 1311.57C761.654 1312.93 766.174 1311.04 767.546 1307.6L767.998 1307.41Z",
    fill: "url(#paint53_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.856 1075.17C320.68 1071.53 319.199 1067.37 315.599 1066.01C311.998 1064.64 307.478 1066.54 305.654 1070.17C303.83 1073.81 305.31 1077.97 308.911 1079.33C312.511 1080.7 317.032 1078.8 318.856 1075.17Z",
    fill: "url(#paint54_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.126 1064.77C413.859 1059.33 411.936 1053.92 406.542 1051.88C401.296 1050.25 395.428 1052.71 392.547 1057.74C389.667 1062.77 391.737 1068.59 397.131 1070.63C401.925 1072.45 408.246 1069.8 411.126 1064.77Z",
    fill: "url(#paint55_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.84 1222.53C652.723 1217.5 650.651 1211.67 645.252 1209.63C640.453 1207.81 633.526 1210.23 631.243 1215.49C628.812 1220.34 630.884 1226.17 635.831 1228.4C641.082 1230.03 646.957 1227.57 649.84 1222.53Z",
    fill: "url(#paint56_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.718 1306.09C835.002 1300.83 833.077 1295.41 828.127 1293.18C823.324 1291.36 816.846 1293.59 814.109 1299.05C811.676 1303.9 813.297 1309.92 818.7 1311.96C823.65 1314.2 829.833 1311.13 832.718 1306.09Z",
    fill: "url(#paint57_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.495 936.117C351.927 931.273 349.855 925.444 344.907 923.211C340.108 921.395 333.782 924.044 330.899 929.078C328.016 934.111 330.088 939.94 335.487 941.983C340.286 943.8 346.76 941.567 349.495 936.117Z",
    fill: "url(#paint58_linear_78_4792)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717.846 1337.48L671.481 1319.93L669.956 1322.97L715.117 1340.06L733.225 1393.94L818.128 1426.08L826.15 1448.64L899.612 1476.45L964.929 1449.1L964.038 1446.59L899.933 1472.96L828.879 1446.06L820.857 1423.49L735.954 1391.35L717.846 1337.48Z",
    fill: "url(#paint59_linear_78_4792)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M994.066 1364.18L917.13 1335.09L835.813 1369.11L780.944 1348.36L755.488 1276.82L577.907 1210.02L515.009 1236.33L456.415 1213.81L454.904 1216.82L514.545 1239.38L577.442 1213.06L752.785 1279.37L778.24 1350.91L835.495 1372.57L916.812 1338.55L992.556 1367.19L994.066 1364.18Z",
    fill: "url(#paint60_linear_78_4792)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M603.469 1165.61L481.054 1119.3L448.642 1132.87L360.015 1098.97L358.48 1102.03L448.17 1135.96L480.581 1122.39L601.029 1167.6L637.509 1270.17L749.622 1312.59L774.889 1383.63L911.093 1434.8L945.48 1420.89L967.902 1429.37L969.437 1426.31L945.803 1417.37L911.565 1431.7L777.636 1381.03L752.369 1309.99L639.8 1267.76L603.469 1165.61Z",
    fill: "url(#paint61_linear_78_4792)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M927.142 1090.18L879.485 1072.54L805.499 1102.84L742.732 1079.61L533.468 1165.29L482.324 1146.36L481.29 1149.05L533.158 1168.58L742.422 1082.91L805.046 1105.74L879.032 1075.45L926.107 1092.87L927.142 1090.18Z",
    fill: "url(#paint62_linear_78_4792)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M922.439 1285.18L850.311 1257.87L806.392 1276.27L647.712 1216.2L644.972 1221.66L806.056 1282.64L849.522 1264.43L917.442 1290.15L935.533 1341.04L999.394 1365.57L1002.44 1359.51L940.678 1336.49L922.439 1285.18Z",
    fill: "url(#paint63_linear_78_4792)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M818.364 1183.84L702.152 1139.91L700.611 1142.97L815.606 1186.45L833.469 1236.64L959.266 1283.83L970.366 1316.5L1019.04 1334.9L1020.58 1331.83L973.124 1313.89L961.716 1281.84L836.227 1234.03L818.364 1183.84Z",
    fill: "url(#paint64_linear_78_4792)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M922.616 1149.11L871.781 1130.23L708.672 1198.53L638.495 1171.97L612.894 1099.96L442.402 1035.07L428.196 995.107L387.262 979.252L384.223 985.307L423.21 1000.06L437.416 1040.02L607.761 1104.5L633.509 1176.93L708.336 1204.89L871.445 1136.59L917.179 1154.26L928.573 1186.31L1054.98 1233.8L1057.72 1228.35L934.159 1181.58L922.616 1149.11Z",
    fill: "url(#paint65_linear_78_4792)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M853.52 1141.76L667.351 1071.34L538.799 1125.13L439.747 1087.67L436.577 1093.27L538.016 1131.64L667.017 1077.66L848.413 1146.27L867.69 1201.91L1037.75 1266.23L1040.77 1260.21L873.099 1196.79L853.52 1141.76Z",
    fill: "url(#paint66_linear_78_4792)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M466.268 950.969L401.685 926.559L400.142 929.63L463.506 953.579L484.55 1012.68L607.773 1059.62L609.316 1056.55L487.462 1010.5L466.268 950.969Z",
    fill: "url(#paint67_linear_78_4792)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.01 1069.64L863.09 988.035L770.785 1026.63L660.741 985.038L595.77 1012.2L551.752 995.567L550.694 998.377L595.453 1015.65L660.425 988.485L770.917 1029.89L862.773 991.481L1076.32 1072.18L1095.4 1125.76L1109.08 1130.93L1110.58 1127.93L1098.09 1123.21L1079.01 1069.64Z",
    fill: "url(#paint68_linear_78_4792)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.58 970.854L892.892 902.234L864.267 914.194L765.704 876.969L571.588 958.075L398.211 892.594L385.32 856.415L382.189 857.723L395.373 894.725L571.719 961.326L765.387 880.408L864.398 917.446L892.576 905.673L1071.89 973.396L1078.78 992.719L1150.03 1019.63L1151.08 1016.83L1081.61 990.588L1074.58 970.854Z",
    fill: "url(#paint69_linear_78_4792)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M694.62 973.416L541.206 915.098L539.659 918.173L691.702 975.607L719.421 1053.42L920.312 1129.3L951.797 1217.68L1050.11 1254.82L1051.65 1251.75L954.565 1215.07L923.08 1126.69L722.188 1050.8L694.62 973.416Z",
    fill: "url(#paint70_linear_78_4792)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M461.627 1195.48C463.147 1192.45 461.815 1188.7 458.814 1187.57C455.814 1186.43 451.745 1188.14 450.226 1191.16C448.706 1194.19 450.038 1197.94 453.038 1199.08C456.039 1200.21 460.107 1198.51 461.627 1195.48Z",
    fill: "url(#paint71_linear_78_4792)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M488.891 1135.9C490.411 1132.87 489.078 1129.12 486.078 1127.98C483.078 1126.85 479.009 1128.55 477.489 1131.58C475.969 1134.61 477.302 1138.36 480.302 1139.49C483.302 1140.63 487.371 1138.93 488.891 1135.9Z",
    fill: "url(#paint72_linear_78_4792)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M407.791 922.597C409.311 919.568 407.979 915.82 404.978 914.685C401.978 913.549 397.909 915.253 396.39 918.281C394.87 921.31 396.202 925.058 399.202 926.194C402.203 927.33 406.271 925.626 407.791 922.597Z",
    fill: "url(#paint73_linear_78_4792)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M614.268 1068.45C615.788 1065.42 614.455 1061.67 611.455 1060.54C608.455 1059.4 604.386 1061.11 602.866 1064.14C601.346 1067.16 602.679 1070.91 605.679 1072.05C608.679 1073.18 612.748 1071.48 614.268 1068.45Z",
    fill: "url(#paint74_linear_78_4792)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M557.672 978.349C559.192 975.32 557.859 971.572 554.859 970.436C551.859 969.3 547.79 971.004 546.27 974.033C544.75 977.061 546.083 980.809 549.083 981.945C552.084 983.081 556.152 981.377 557.672 978.349Z",
    fill: "url(#paint75_linear_78_4792)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M582.633 948.503C584.153 945.474 582.821 941.726 579.82 940.591C576.82 939.455 572.751 941.159 571.231 944.187C569.711 947.216 571.044 950.964 574.044 952.1C577.045 953.236 581.113 951.532 582.633 948.503Z",
    fill: "url(#paint76_linear_78_4792)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M808.375 1112.26C809.895 1109.23 808.563 1105.48 805.562 1104.35C802.562 1103.21 798.493 1104.91 796.974 1107.94C795.454 1110.97 796.786 1114.72 799.786 1115.85C802.787 1116.99 806.855 1115.29 808.375 1112.26Z",
    fill: "url(#paint77_linear_78_4792)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M580.908 1200.23C582.428 1197.2 581.096 1193.45 578.095 1192.32C575.095 1191.18 571.027 1192.89 569.507 1195.92C567.987 1198.94 569.319 1202.69 572.32 1203.83C575.32 1204.96 579.388 1203.26 580.908 1200.23Z",
    fill: "url(#paint78_linear_78_4792)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M707.143 1132.46C708.663 1129.43 707.33 1125.68 704.33 1124.54C701.329 1123.41 697.261 1125.11 695.741 1128.14C694.221 1131.17 695.554 1134.92 698.554 1136.05C701.554 1137.19 705.623 1135.48 707.143 1132.46Z",
    fill: "url(#paint79_linear_78_4792)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M775.631 1025.13C777.151 1022.1 775.818 1018.36 772.818 1017.22C769.818 1016.08 765.749 1017.79 764.229 1020.82C762.709 1023.84 764.042 1027.59 767.042 1028.73C770.043 1029.86 774.111 1028.16 775.631 1025.13Z",
    fill: "url(#paint80_linear_78_4792)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M388.537 828.258C390.057 825.23 388.725 821.482 385.724 820.346C382.724 819.21 378.656 820.914 377.136 823.943C375.616 826.971 376.948 830.719 379.949 831.855C382.949 832.991 387.017 831.287 388.537 828.258Z",
    fill: "url(#paint81_linear_78_4792)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M547.049 899.926C548.569 896.897 547.236 893.149 544.236 892.014C541.236 890.878 537.167 892.582 535.647 895.61C534.127 898.639 535.46 902.387 538.46 903.523C541.461 904.659 545.529 902.955 547.049 899.926Z",
    fill: "url(#paint82_linear_78_4792)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M727.514 1048.7C729.034 1045.67 727.701 1041.92 724.701 1040.78C721.7 1039.65 717.632 1041.35 716.112 1044.38C714.592 1047.41 715.925 1051.16 718.925 1052.29C721.926 1053.43 725.542 1051.91 727.514 1048.7Z",
    fill: "url(#paint83_linear_78_4792)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M645.278 1269.63C646.798 1266.6 645.465 1262.85 642.465 1261.72C639.464 1260.58 635.396 1262.28 633.876 1265.31C632.356 1268.34 633.688 1272.09 636.689 1273.23C639.689 1274.36 643.758 1272.66 645.278 1269.63Z",
    fill: "url(#paint84_linear_78_4792)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M758.533 1281.76C760.053 1278.73 758.721 1274.98 755.721 1273.85C752.72 1272.71 748.652 1274.41 747.132 1277.44C745.612 1280.47 746.944 1284.22 749.945 1285.36C752.945 1286.49 757.014 1284.79 758.533 1281.76Z",
    fill: "url(#paint85_linear_78_4792)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M366.303 1079.27C367.823 1076.24 366.49 1072.49 363.49 1071.36C360.49 1070.22 356.421 1071.92 354.901 1074.95C353.381 1077.98 354.714 1081.73 357.714 1082.86C360.715 1084 364.783 1082.3 366.303 1079.27Z",
    fill: "url(#paint86_linear_78_4792)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M446.662 1069.94C448.791 1065.7 447.014 1060.7 442.664 1058.69C438.461 1057.1 432.887 1058.96 430.454 1063.8C428.021 1068.65 430.251 1073.46 434.453 1075.05C439.255 1076.87 444.081 1074.37 446.662 1069.94Z",
    fill: "url(#paint87_linear_78_4792)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M654.86 1207.54C657.439 1203.11 655.211 1198.3 650.862 1196.29C646.21 1194.89 641.089 1196.56 638.657 1201.4C636.529 1205.64 638.306 1210.64 642.655 1212.65C646.855 1214.24 652.28 1211.97 654.86 1207.54Z",
    fill: "url(#paint88_linear_78_4792)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M814.915 1280.63C817.041 1276.39 815.718 1271.21 810.922 1269.4C806.275 1268 801.308 1270.08 798.731 1274.5C796.302 1279.34 798.076 1284.34 802.724 1285.73C807.371 1287.13 812.79 1284.86 814.915 1280.63Z",
    fill: "url(#paint89_linear_78_4792)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M393.203 957.372C395.331 953.132 393.555 948.134 389.206 946.128C385.005 944.538 379.581 946.809 377.001 951.239C375.021 955.896 376.65 960.477 380.998 962.483C385.199 964.073 390.623 961.802 393.203 957.372Z",
    fill: "url(#paint90_linear_78_4792)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M677.338 1297.52C684.539 1300.42 687.633 1308.9 684.298 1316.6C680.809 1323.86 671.9 1327.5 664.254 1324.78C657.053 1321.87 653.96 1313.39 657.294 1305.7C660.784 1298.43 669.692 1294.79 677.338 1297.52ZM665.417 1322.35C671.418 1324.77 678.99 1321.68 681.898 1315.63C684.805 1309.57 682.176 1302.36 676.176 1299.94C670.175 1297.52 662.602 1300.61 659.694 1306.67C656.787 1312.72 659.416 1319.93 665.417 1322.35Z",
    fill: "url(#paint91_linear_78_4792)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M462.122 1181.34C469.323 1184.25 472.571 1193.15 469.081 1200.42C465.592 1207.69 456.238 1211.51 449.037 1208.6C441.836 1205.7 438.588 1196.79 442.077 1189.52C445.567 1182.26 454.921 1178.44 462.122 1181.34ZM450.2 1206.18C456.201 1208.6 463.773 1205.51 466.681 1199.45C469.589 1193.4 466.96 1186.19 460.959 1183.77C454.958 1181.35 447.386 1184.44 444.478 1190.49C441.57 1196.55 444.199 1203.76 450.2 1206.18Z",
    fill: "url(#paint92_linear_78_4792)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M557.743 961.845C564.944 964.751 568.192 973.655 564.702 980.924C561.213 988.192 552.304 991.828 544.658 989.104C537.457 986.198 534.209 977.295 537.699 970.026C541.188 962.757 550.096 959.121 557.743 961.845ZM545.821 986.681C551.822 989.103 559.394 986.012 562.302 979.955C565.21 973.897 562.581 966.69 556.58 964.268C550.579 961.847 543.007 964.937 540.099 970.994C537.191 977.052 539.82 984.259 545.821 986.681Z",
    fill: "url(#paint93_linear_78_4792)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M387.833 813.573C395.034 816.479 398.127 824.958 394.792 832.651C391.303 839.92 382.394 843.556 374.748 840.831C367.547 837.925 364.299 829.022 367.788 821.753C371.278 814.484 380.632 810.667 387.833 813.573ZM375.911 838.408C381.912 840.83 389.484 837.74 392.392 831.682C395.3 825.625 392.67 818.418 386.67 815.996C380.669 813.574 373.097 816.664 370.189 822.722C367.281 828.779 369.91 835.987 375.911 838.408Z",
    fill: "url(#paint94_linear_78_4792)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M546.69 883.588C553.891 886.494 557.139 895.397 553.65 902.666C550.16 909.935 541.252 913.571 533.605 910.847C526.404 907.94 523.157 899.037 526.646 891.768C530.135 884.499 539.489 880.682 546.69 883.588ZM534.768 908.424C540.769 910.845 548.342 907.755 551.249 901.698C554.157 895.64 551.528 888.433 545.527 886.011C539.526 883.589 531.954 886.68 529.046 892.737C526.138 898.794 528.768 906.002 534.768 908.424Z",
    fill: "url(#paint95_linear_78_4792)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M408.175 908.462C414.33 911.308 417.405 918.334 414.052 924.573C411.144 930.63 403.281 934.326 397.125 931.481C390.97 928.635 387.895 921.609 391.248 915.37C394.447 908.707 402.174 906.04 408.175 908.462ZM397.997 929.663C403.398 931.843 409.634 929.298 411.806 924.028C414.423 918.576 412.258 912.641 407.012 910.885C401.611 908.706 395.375 911.251 393.203 916.521C390.586 921.972 392.751 927.908 398.152 930.087L397.997 929.663Z",
    fill: "url(#paint96_linear_78_4792)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M365.398 1065.63C371.554 1068.47 374.183 1075.68 371.275 1081.74C367.922 1087.98 360.35 1091.07 354.349 1088.65C348.193 1085.8 345.564 1078.59 348.472 1072.54C351.825 1066.3 359.397 1063.21 365.398 1065.63ZM355.221 1086.83C360.622 1089.01 366.858 1086.46 369.475 1081.01C372.092 1075.56 369.927 1069.63 364.526 1067.45C359.125 1065.27 352.889 1067.81 350.272 1073.26C347.655 1078.71 349.82 1084.65 355.221 1086.83Z",
    fill: "url(#paint97_linear_78_4792)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M488.146 1122.7C494.591 1124.94 497.374 1132.57 494.022 1138.81C491.114 1144.87 483.098 1148.14 477.098 1145.72C470.944 1142.87 468.315 1135.67 471.223 1129.61C474.575 1123.37 481.991 1119.86 488.146 1122.7ZM477.97 1143.9C483.37 1146.08 489.605 1143.54 492.222 1138.08C494.838 1132.63 492.673 1126.7 487.274 1124.52C481.874 1122.34 475.639 1124.89 473.468 1130.15C470.851 1135.61 473.016 1141.54 478.261 1143.29L477.97 1143.9Z",
    fill: "url(#paint98_linear_78_4792)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M817.13 1259.04C827.332 1263.16 831.508 1274.6 826.41 1284.48C821.466 1294.78 809.44 1299.68 799.684 1295.39C789.483 1291.27 785.307 1279.82 790.405 1269.95C795.348 1259.65 807.374 1254.74 817.13 1259.04ZM801.138 1292.36C809.539 1295.75 819.338 1291.75 823.409 1283.27C827.48 1274.79 824.078 1265.46 815.677 1262.07C807.275 1258.68 797.476 1262.68 793.405 1271.16C789.334 1279.64 792.737 1288.97 801.138 1292.36Z",
    fill: "url(#paint99_linear_78_4792)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M656.478 1185.67C666.68 1189.78 670.855 1201.23 665.757 1211.1C660.814 1221.4 648.788 1226.31 639.032 1222.01C628.83 1217.89 624.655 1206.45 629.752 1196.57C634.696 1186.28 646.722 1181.37 656.478 1185.67ZM640.485 1218.98C648.887 1222.37 658.686 1218.37 662.757 1209.89C666.828 1201.41 663.425 1192.08 655.024 1188.69C646.623 1185.3 636.824 1189.3 632.753 1197.78C628.682 1206.26 632.084 1215.59 640.485 1218.98Z",
    fill: "url(#paint100_linear_78_4792)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M446.976 1048.57C457.178 1052.68 461.353 1064.13 456.256 1074C451.312 1084.3 439.286 1089.21 429.53 1084.91C419.328 1080.8 415.153 1069.35 420.25 1059.47C425.194 1049.18 437.22 1044.27 446.976 1048.57ZM430.984 1081.88C439.385 1085.27 449.184 1081.27 453.255 1072.79C457.326 1064.31 453.923 1054.99 445.522 1051.6C437.121 1048.21 427.322 1052.2 423.251 1060.69C419.18 1069.17 422.582 1078.49 430.984 1081.88Z",
    fill: "url(#paint101_linear_78_4792)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M394.814 935.5C405.015 939.617 409.191 951.064 404.093 960.938C399.15 971.235 387.124 976.143 377.368 971.845C367.166 967.728 362.99 956.281 368.088 946.407C373.031 936.109 385.058 931.201 394.814 935.5ZM378.821 968.816C387.223 972.206 397.022 968.207 401.093 959.727C405.164 951.246 401.761 941.919 393.36 938.529C384.959 935.138 375.16 939.138 371.089 947.618C367.018 956.098 370.42 965.425 378.821 968.816Z",
    fill: "url(#paint102_linear_78_4792)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1127.47 -366.751L1016.26 -320.269L894.438 -366.492L815.357 -333.092L782.641 -227.118L525.869 -120.139L432.229 -155.67L347.587 -119.946L344.977 -124.041L431.721 -160.297L525.36 -124.766L778.485 -230.911L811.201 -336.886L894.052 -371.516L1015.87 -325.293L1124.86 -370.846L1127.47 -366.751Z",
    fill: "url(#paint103_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.266 -55.0613L389.216 18.9949L340.706 0.574482L212.427 53.8791L210.212 49.8785L340.313 -4.54003L388.824 13.8804L562.48 -58.7564L609.348 -210.683L771.691 -278.588L804.349 -384.452L1001.2 -466.789L1052.79 -447.196L1085.16 -461.087L1087.69 -456.515L1053.19 -442.082L1001.59 -461.674L808.701 -380.993L776.043 -275.13L613.259 -207.392L566.266 -55.0613Z",
    fill: "url(#paint104_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.45 39.5373L976.169 67.7322L865.612 26.886L775.224 63.6717L462.964 -51.6956L389.354 -21.7385L387.355 -25.8392L462.588 -56.4572L774.729 59.2863L864.695 22.3448L975.674 63.3469L1042.91 35.6569L1045.45 39.5373Z",
    fill: "url(#paint105_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.65 -247.579L923.357 -203.933L857.785 -228.845L628.579 -133.271L624.189 -141.206L856.445 -238.755L922.017 -213.843L1019.58 -254.673L1043.06 -330.814L1135.7 -369.933L1140.4 -361.431L1051.25 -324.12L1027.65 -247.579Z",
    fill: "url(#paint106_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.757 -94.3587L712.718 -24.482L710.494 -28.4969L876.953 -98.0666L899.421 -172.44L1081.22 -248.42L1096.12 -296.674L1166.57 -326.116L1168.66 -321.696L1100.49 -293.203L1085.59 -244.95L903.792 -168.969L880.757 -94.3587Z",
    fill: "url(#paint107_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.18 -46.9171L962.013 -16.6513L717.768 -109.432L616.511 -67.0618L583.349 40.4756L337.2 143.474L318.832 203.04L259.532 227.853L255.275 219.537L310.659 196.362L329.586 136.563L575.736 33.564L608.774 -73.5734L716.868 -119.152L960.553 -26.1377L1027.13 -53.9943L1041.92 -101.966L1223.73 -178.045L1228.55 -169.963L1049.97 -94.8891L1035.18 -46.9171Z",
    fill: "url(#paint108_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.413 -33.1334L665.692 79.2019L473.537 6.2793L330.553 66.0519L325.886 57.625L472.208 -3.54314L664.674 69.9412L926.285 -39.7678L951.664 -121.986L1197.14 -224.95L1201.81 -216.523L959.792 -115.352L934.413 -33.1334Z",
    fill: "url(#paint109_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.937 268.199L283.197 306.946L280.526 302.758L371.559 264.725L399.017 175.823L577.669 101.183L580.214 105.777L403.269 179.703L375.937 268.199Z",
    fill: "url(#paint110_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.32 61.4096L958.136 191.699L820.236 139.422L661.101 205.875L563.836 169.002L500.626 195.398L498.145 190.924L563.019 163.833L660.716 200.87L819.728 134.813L957.196 186.925L1265.48 58.1891L1290.04 -21.2895L1310 -29.625L1312.18 -25.7099L1293.88 -18.069L1269.32 61.4096Z",
    fill: "url(#paint111_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.78 207.096L1005.88 316.718L963.6 300.701L820.935 359.885L531.413 250.216L280.707 354.826L264.242 408.065L259.496 406.267L276.448 351.45L530.475 245.456L820.429 355.288L962.662 295.94L1004.95 311.957L1263.95 203.884L1272.98 174.701L1375.37 131.98L1377.96 136.048L1276.68 178.307L1267.78 207.096Z",
    fill: "url(#paint112_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.06 221.973L489.199 314.606L486.966 310.58L707.116 218.662L742.365 102.999L1033.24 -18.4478L1073.96 -150.209L1216.42 -209.335L1218.65 -205.308L1078.35 -146.728L1037.63 -14.9671L746.754 106.479L711.06 221.973Z",
    fill: "url(#paint113_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.815 -4.74516C401.319 -0.219097 399.715 4.98078 395.238 6.85451C390.76 8.72825 385.087 6.57322 382.583 2.04715C380.079 -2.47891 381.682 -7.67879 386.16 -9.55253C390.637 -11.4263 396.31 -9.27123 399.251 -4.57939L398.815 -4.74516Z",
    fill: "url(#paint114_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.422 313.389C293.928 317.92 292.323 323.125 287.841 325.001C283.359 326.877 277.681 324.719 275.174 320.189C272.667 315.658 274.272 310.453 278.878 308.177C283.36 306.301 289.038 308.458 291.545 312.989L291.422 313.389Z",
    fill: "url(#paint115_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.392 87.066C589.899 91.5967 588.294 96.8019 583.812 98.6776C579.33 100.553 573.651 98.396 571.145 93.8652C568.638 89.3344 570.243 84.1292 574.849 81.8531C579.331 79.9774 585.009 82.1347 587.516 86.6655L587.392 87.066Z",
    fill: "url(#paint116_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.654 223.395C511.159 227.922 509.555 233.121 505.077 234.995C500.6 236.869 494.927 234.714 492.423 230.188C489.918 225.662 491.522 220.462 496 218.588C500.477 216.714 506.15 218.869 508.654 223.395Z",
    fill: "url(#paint117_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.379 265.515C549.885 270.046 548.28 275.251 543.798 277.127C539.316 279.002 533.638 276.845 531.131 272.314C528.624 267.783 530.229 262.578 534.835 260.302C539.317 258.426 544.995 260.584 547.502 265.114L547.379 265.515Z",
    fill: "url(#paint118_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.862 -11.9194C722.366 -7.39329 720.762 -2.19342 716.285 -0.31968C711.807 1.55406 706.134 -0.600977 703.63 -5.12704C701.126 -9.65311 702.729 -14.853 707.207 -16.7267C711.684 -18.6005 717.357 -16.4454 719.862 -11.9194Z",
    fill: "url(#paint119_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.641 141.658C829.145 146.184 827.541 151.384 823.064 153.258C818.586 155.132 812.913 152.977 810.409 148.451C807.905 143.924 809.508 138.725 813.986 136.851C818.464 134.977 824.136 137.132 826.641 141.658Z",
    fill: "url(#paint120_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.261 453.513C270.763 458.034 269.161 463.229 264.688 465.101C260.214 466.972 254.547 464.82 251.609 460.133C249.107 455.611 250.709 450.417 255.182 448.545C259.656 446.673 265.323 448.826 267.825 453.348L268.261 453.513Z",
    fill: "url(#paint121_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.158 339.001C499.662 343.527 498.059 348.727 493.581 350.601C489.104 352.475 483.431 350.32 480.927 345.794C478.422 341.268 480.026 336.068 484.504 334.194C488.981 332.32 494.654 334.475 497.158 339.001Z",
    fill: "url(#paint122_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.744 110.035C757.245 114.556 755.644 119.75 751.17 121.622C746.697 123.494 741.029 121.341 738.091 116.654C735.59 112.133 737.191 106.938 741.665 105.067C746.138 103.195 751.806 105.348 754.308 109.869L754.744 110.035Z",
    fill: "url(#paint123_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.653 85.6585C224.157 90.1845 222.553 95.3844 218.076 97.2581C213.598 99.1319 207.925 96.9768 205.421 92.4508C202.917 87.9247 204.52 82.7248 208.998 80.8511C213.475 78.9774 219.148 81.1324 221.653 85.6585Z",
    fill: "url(#paint124_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.271 94.6675C344.026 101.455 341.807 108.653 335.092 111.462C328.377 114.272 320.524 111.289 316.769 104.502C313.013 97.7146 315.233 90.5168 321.948 87.707C328.662 84.8971 336.392 88.2801 340.271 94.6675Z",
    fill: "url(#paint125_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.095 263.07C271.855 269.867 269.196 276.911 262.908 279.891C256.62 282.871 248.319 279.717 244.995 273.085C241.548 266.854 243.894 259.245 250.182 256.264C256.346 253.685 264.771 256.438 268.531 263.236L268.095 263.07Z",
    fill: "url(#paint126_linear_78_4792)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016.09 -264.143L933.794 -229.745L844.057 -263.796L785.238 -239.557L760.976 -160.969L571.364 -81.716L502.001 -108.035L439.168 -81.7723L437.613 -84.5792L501.681 -111.704L570.61 -85.5491L757.876 -163.476L782.138 -242.063L843.303 -267.629L933.474 -233.414L1014.1 -267.114L1016.09 -264.143Z",
    fill: "url(#paint127_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.199 -33.749L469.962 21.1444L434.239 7.57984L339.33 46.9263L337.748 44.0686L433.913 3.84493L469.636 17.4096L598.045 -36.3009L632.824 -149.038L753.188 -199.031L777.371 -277.422L922.751 -338.231L960.679 -323.829L985.003 -334.003L986.46 -330.741L961.004 -320.094L923.076 -334.496L779.96 -274.633L756.343 -196.48L635.853 -146.082L601.199 -33.749Z",
    fill: "url(#paint128_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.332 36.5395L904.033 57.0894L822.17 26.8441L755.596 53.938L524.776 -31.3411L470.11 -9.09324L468.716 -12.1299L524.345 -34.4421L755.165 50.8371L821.858 23.3671L903.721 53.6123L953.516 33.3469L955.332 36.5395Z",
    fill: "url(#paint129_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.281 -176.021L865.029 -144.04L816.506 -162.474L647.053 -91.2085L643.603 -97.4434L815.737 -169.482L864.259 -151.047L936.152 -181.483L953.45 -237.586L1022.42 -266.448L1025.86 -260.213L959.702 -232.524L942.281 -176.021Z",
    fill: "url(#paint130_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.744 -62.9962L709.328 -10.9977L707.739 -13.8653L830.577 -65.557L847.603 -120.703L982.12 -176.57L993.137 -212.253L1044.96 -234.265L1046.87 -230.824L995.862 -209.86L984.845 -174.177L850.77 -118.142L833.744 -62.9962Z",
    fill: "url(#paint131_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.917 -27.5777L893.777 -5.27153L713.214 -73.8611L638.252 -42.494L613.72 37.0578L431.909 113.134L418.226 157.508L374.155 175.6L370.713 169.38L412.11 152.058L425.671 108.085L608.041 31.7743L632.449 -47.3777L712.446 -80.8514L892.573 -12.4275L941.802 -33.0268L952.65 -68.2055L1087.47 -124.619L1090.91 -118.399L958.889 -63.1561L947.917 -27.5777Z",
    fill: "url(#paint132_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.135 -17.1869L674.518 65.842L532.247 11.8506L426.541 56.0396L423.118 49.86L531.607 4.50809L673.877 58.4994L867.487 -22.4363L886.245 -83.2052L1067.61 -159.024L1071.04 -152.844L892.015 -78.3529L873.135 -17.1869Z",
    fill: "url(#paint133_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.368 205.582L391.659 233.936L389.625 230.897L457.321 202.613L477.504 137.262L609.485 82.1197L611.519 85.1585L480.677 139.825L460.368 205.582Z",
    fill: "url(#paint134_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.09 52.5702L890.984 148.658L788.843 110.379L671.296 159.464L599.104 132.098L552.529 151.547L550.669 148.191L598.785 128.443L670.976 155.81L788.523 106.724L890.11 145.234L1118 50.0731L1136.2 -8.8428L1151.05 -14.6988L1152.6 -11.9024L1139.29 -6.34569L1121.09 52.5702Z",
    fill: "url(#paint135_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.85 160.376L926.148 241.202L895.081 229.434L789.373 273.542L574.925 192.31L389.642 269.278L377.446 308.715L374.426 307.571L386.988 266.95L574.606 188.665L789.054 269.897L894.331 225.625L925.708 237.951L1117.2 158.049L1123.91 136.358L1199.73 104.721L1201.16 107.904L1126.56 138.686L1119.85 160.376Z",
    fill: "url(#paint136_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.206 171.352L544.079 239.525L542.484 236.649L705.026 168.783L731.544 82.9774L946.556 -6.7961L976.594 -103.989L1081.53 -147.804L1083.57 -144.759L979.774 -101.42L949.737 -4.22781L734.599 85.9522L708.206 171.352Z",
    fill: "url(#paint137_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.346 3.37141C479.224 6.76596 477.991 10.7659 474.633 12.1712C471.274 13.5765 466.911 11.9188 465.032 8.52421C463.154 5.12966 464.388 1.12974 467.746 -0.275566C471.104 -1.68087 475.468 -0.0231417 477.346 3.37141Z",
    fill: "url(#paint138_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.807 239.012C399.685 242.407 398.452 246.406 395.093 247.812C391.735 249.217 387.372 247.559 385.493 244.165C383.615 240.77 384.848 236.77 388.207 235.365C391.565 233.96 395.929 235.618 397.807 239.012Z",
    fill: "url(#paint139_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.623 71.7479C618.502 75.1425 617.268 79.1424 613.91 80.5477C610.552 81.953 606.188 80.2953 604.31 76.9007C602.432 73.5062 603.665 69.5063 607.023 68.101C610.382 66.6957 614.745 68.3534 616.623 71.7479Z",
    fill: "url(#paint140_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.623 171.967C560.501 175.361 559.268 179.361 555.91 180.766C552.552 182.171 548.188 180.514 546.31 177.119C544.432 173.725 545.665 169.725 549.023 168.32C552.381 166.914 556.745 168.572 558.623 171.967Z",
    fill: "url(#paint141_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.098 203.497C588.976 206.892 587.743 210.892 584.385 212.297C581.026 213.702 576.663 212.045 574.784 208.65C572.906 205.255 574.14 201.256 577.498 199.85C580.856 198.445 585.22 200.103 587.098 203.497Z",
    fill: "url(#paint142_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.815 15.9852C827.693 19.3798 826.46 23.3797 823.101 24.785C819.743 26.1903 815.379 24.5326 813.501 21.138C811.623 17.7435 812.856 13.7436 816.215 12.3383C819.573 10.933 823.937 12.5907 825.815 15.9852Z",
    fill: "url(#paint143_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.415 -1.61736C716.293 1.77719 715.059 5.77711 711.701 7.18241C708.343 8.58772 703.979 6.92999 702.101 3.53544C700.223 0.140891 701.456 -3.85903 704.814 -5.26434C708.173 -6.66964 712.536 -5.01191 714.415 -1.61736Z",
    fill: "url(#paint144_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.834 111.798C795.712 115.192 794.479 119.192 791.121 120.597C787.762 122.003 783.399 120.345 781.521 116.951C779.642 113.556 780.876 109.556 784.234 108.151C787.592 106.745 791.956 108.403 793.834 111.798Z",
    fill: "url(#paint145_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.827 342.312C382.705 345.707 381.471 349.707 378.113 351.112C374.755 352.517 370.391 350.86 368.513 347.465C366.635 344.071 367.868 340.071 371.226 338.665C374.585 337.26 378.948 338.918 380.827 342.312Z",
    fill: "url(#paint146_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.983 257.716C551.861 261.11 550.628 265.11 547.269 266.515C543.911 267.921 539.547 266.263 537.669 262.869C535.791 259.474 537.024 255.474 540.383 254.069C543.741 252.663 548.105 254.321 549.983 257.716Z",
    fill: "url(#paint147_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.389 88.3509C742.267 91.7454 741.034 95.7452 737.676 97.1505C734.317 98.5558 729.954 96.8981 728.075 93.5035C726.197 90.109 727.431 86.1092 730.789 84.7039C734.147 83.2986 738.511 84.9563 740.389 88.3509Z",
    fill: "url(#paint148_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.08 70.5364C347.959 73.931 346.725 77.9307 343.367 79.336C340.009 80.7413 335.645 79.0836 333.767 75.6891C331.889 72.2945 333.122 68.2947 336.48 66.8894C339.838 65.4841 344.202 67.1419 346.08 70.5364Z",
    fill: "url(#paint149_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.085 77.0521C436.9 82.1402 435.298 87.3361 430.264 89.4424C425.353 91.1491 419.684 88.9957 416.746 84.3074C413.93 79.2193 415.532 74.0234 420.566 71.9171C425.164 69.645 431.269 71.9641 434.085 77.0521Z",
    fill: "url(#paint150_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.275 201.472C382.78 206 381.052 211.602 376.45 213.876C371.847 216.151 365.859 213.429 362.917 208.736C360.099 203.642 361.703 198.44 366.742 196.331C371.345 194.057 377.456 196.378 380.275 201.472Z",
    fill: "url(#paint151_linear_78_4792)"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M975.877 -226.978L904.267 -197.393L825.799 -227.167L774.519 -205.388L753.443 -137.118L587.737 -67.8565L527.044 -90.8863L472.427 -67.7123L470.872 -70.5194L526.601 -94.1582L587.294 -71.1283L750.776 -139.46L771.852 -207.73L825.234 -230.042L903.702 -200.268L974.322 -229.785L975.877 -226.978Z",
    fill: "url(#paint152_linear_78_4792)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M613.516 -26.0316L499.255 21.7616L467.944 9.87212L385.359 44.4158L383.653 41.9622L467.494 6.54139L498.805 18.4308L611.244 -28.2484L641.534 -126.434L746.303 -170.609L767.244 -238.491L894.515 -291.726L927.59 -279.166L948.519 -287.92L950.225 -285.467L928.04 -275.835L894.965 -288.395L770.082 -236.51L749.016 -168.225L643.806 -124.217L613.516 -26.0316Z",
    fill: "url(#paint153_linear_78_4792)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M922.689 35.2996L878.309 53.36L806.997 27.0154L748.545 50.8023L546.849 -23.7106L499.34 -4.70469L498.129 -6.83282L546.418 -26.8112L748.114 47.7017L806.566 23.9149L877.877 50.2593L921.598 32.7954L922.689 35.2996Z",
    fill: "url(#paint154_linear_78_4792)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M911.44 -150.358L844.157 -122.2L801.755 -138.309L653.733 -76.3619L650.911 -81.4631L801.176 -144.349L843.264 -128.807L906.498 -154.921L921.696 -204.211L981.129 -229.084L984.388 -223.816L926.637 -199.647L911.44 -150.358Z",
    fill: "url(#paint155_linear_78_4792)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M816.814 -51.4918L708.308 -6.1427L706.72 -9.01025L813.964 -53.479L828.861 -101.731L946.456 -150.879L955.528 -181.863L1000.98 -200.857L1002.69 -198.395L958.378 -179.875L948.738 -148.654L831.586 -99.3379L816.814 -51.4918Z",
    fill: "url(#paint156_linear_78_4792)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M916.262 -20.6127L868.833 -1.11483L711.381 -60.9255L645.927 -33.5371L624.6 35.6232L465.721 102.105L453.762 140.882L415.721 156.801L412.469 151.546L448.832 136.33L460.79 97.5523L619.546 31.4705L640.997 -38.0895L710.926 -67.3507L868.378 -7.54L910.895 -25.3309L920.388 -56.1132L1038.43 -105.506L1041.12 -100.017L925.878 -51.7949L916.262 -20.6127Z",
    fill: "url(#paint157_linear_78_4792)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M851.319 -11.6053L677.746 60.9534L553.699 13.8784L461.472 52.086L458.238 46.8656L552.813 7.33058L677.294 54.5701L846.416 -16.1281L862.288 -69.1147L1020.84 -135.394L1024.07 -130.174L867.747 -64.8245L851.319 -11.6053Z",
    fill: "url(#paint158_linear_78_4792)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M490.847 182.876L430.661 207.667L429.07 204.796L488.118 180.48L505.797 123.24L620.856 74.8166L622.447 77.6876L508.526 125.636L490.847 182.876Z",
    fill: "url(#paint159_linear_78_4792)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.63 49.4487L866.476 133.104L777.423 99.3447L674.722 142.576L612.039 118.813L571.13 135.552L570.011 132.92L611.597 115.554L674.28 139.316L777.292 96.6445L865.912 130.24L1064.97 47.1153L1080.86 -4.28965L1093.61 -9.61532L1095.16 -6.81871L1083.51 -1.95631L1067.63 49.4487Z",
    fill: "url(#paint160_linear_78_4792)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.94 143.374L897.583 214.04L869.968 203.579L777.973 242.309L590.829 170.979L429.1 238.805L418.489 273.117L415.469 271.972L426.445 236.478L590.698 168.285L777.532 239.058L869.836 200.886L897.02 211.183L1064.16 141.441L1070.02 122.511L1136.43 94.7991L1137.55 97.4248L1072.67 124.838L1066.94 143.374Z",
    fill: "url(#paint161_linear_78_4792)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M707.149 152.983L563.999 212.752L562.404 209.876L704.414 150.583L727.413 76.1639L915.175 -2.58594L941.441 -87.5783L1033.14 -125.51L1034.86 -123.04L944.177 -85.1786L917.91 -0.186205L730.274 78.157L707.149 152.983Z",
    fill: "url(#paint162_linear_78_4792)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M505.464 6.24808C507.029 9.07687 505.919 12.6767 503.121 13.8478C500.322 15.0189 496.395 13.5269 494.829 10.6981C493.264 7.86931 494.374 4.26948 497.173 3.0984C499.971 1.92731 503.899 3.41929 505.464 6.24808Z",
    fill: "url(#paint163_linear_78_4792)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M436.132 212.168C437.697 214.997 436.587 218.597 433.788 219.768C430.99 220.939 427.063 219.447 425.497 216.618C423.932 213.789 425.042 210.189 427.841 209.018C430.639 207.847 434.567 209.339 436.132 212.168Z",
    fill: "url(#paint164_linear_78_4792)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M626.991 65.7239C628.557 68.5527 627.446 72.1525 624.648 73.3236C621.849 74.4947 617.922 73.0027 616.357 70.1739C614.792 67.3451 615.902 63.7453 618.7 62.5742C621.499 61.4031 625.426 62.8951 626.991 65.7239Z",
    fill: "url(#paint165_linear_78_4792)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M576.409 153.768C577.974 156.597 576.864 160.197 574.066 161.368C571.267 162.539 567.34 161.048 565.775 158.219C564.21 155.39 565.32 151.79 568.118 150.619C570.917 149.448 574.844 150.94 576.409 153.768Z",
    fill: "url(#paint166_linear_78_4792)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M601.351 180.774C602.916 183.603 601.806 187.203 599.007 188.374C596.209 189.545 592.281 188.053 590.716 185.225C589.151 182.396 590.261 178.796 593.06 177.625C595.858 176.454 599.786 177.946 601.351 180.774Z",
    fill: "url(#paint167_linear_78_4792)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M809.556 17.48C811.121 20.3088 810.011 23.9086 807.212 25.0797C804.414 26.2508 800.486 24.7588 798.921 21.93C797.356 19.1012 798.466 15.5014 801.265 14.3303C804.063 13.1592 807.991 14.6512 809.556 17.48Z",
    fill: "url(#paint168_linear_78_4792)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M712.689 1.98895C714.254 4.81774 713.144 8.41773 710.345 9.58881C707.546 10.7599 703.619 9.26798 702.054 6.43919C700.489 3.6104 701.599 0.0104089 704.398 -1.16068C707.196 -2.33176 711.123 -0.839849 712.689 1.98895Z",
    fill: "url(#paint169_linear_78_4792)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M781.804 100.98C783.369 103.809 782.259 107.409 779.46 108.58C776.662 109.751 772.734 108.259 771.169 105.43C769.604 102.601 770.714 99.0013 773.513 97.8302C776.311 96.6591 780.239 98.151 781.804 100.98Z",
    fill: "url(#paint170_linear_78_4792)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M421.312 302.45C422.877 305.278 421.767 308.878 418.968 310.049C416.17 311.22 412.242 309.729 410.677 306.9C409.112 304.071 410.222 300.471 413.021 299.3C415.819 298.129 419.746 299.621 421.312 302.45Z",
    fill: "url(#paint171_linear_78_4792)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M569.198 228.622C570.763 231.451 569.653 235.051 566.855 236.222C564.056 237.393 560.129 235.901 558.564 233.072C556.999 230.244 558.109 226.644 560.907 225.473C563.706 224.302 567.633 225.793 569.198 228.622Z",
    fill: "url(#paint172_linear_78_4792)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M735.105 80.7822C736.67 83.611 735.56 87.2109 732.761 88.382C729.962 89.5531 726.035 88.0612 724.47 85.2324C722.905 82.4036 724.015 78.8036 726.814 77.6325C729.612 76.4614 733.103 77.7876 735.105 80.7822Z",
    fill: "url(#paint173_linear_78_4792)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M390.991 64.9106C392.557 67.7394 391.446 71.3394 388.648 72.5105C385.849 73.6816 381.922 72.1896 380.357 69.3608C378.792 66.532 379.902 62.932 382.7 61.761C385.499 60.5899 389.426 62.0818 390.991 64.9106Z",
    fill: "url(#paint174_linear_78_4792)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M467.623 70.8604C469.815 74.8207 468.335 79.6204 464.293 81.6599C460.375 83.2995 455.016 81.7102 452.511 77.1841C450.007 72.6581 451.923 68.0241 455.841 66.3846C459.759 64.7451 464.996 66.7343 467.623 70.8604Z",
    fill: "url(#paint175_linear_78_4792)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M421.143 179.267C423.334 183.228 421.854 188.027 417.812 190.067C413.894 191.706 408.658 189.717 406.03 185.591C403.962 181.231 405.319 176.831 409.36 174.791C413.278 173.152 418.515 175.141 421.143 179.267Z",
    fill: "url(#paint176_linear_78_4792)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M557.787 162.374C554.211 155.584 556.96 146.997 563.678 143.973C570.395 140.95 578.973 144.088 582.978 151.036C586.554 157.826 583.936 166.004 577.088 169.436C570.239 172.869 561.792 169.321 557.787 162.374ZM560.026 161.366C563.006 167.025 570.298 169.693 575.896 167.173C581.494 164.653 583.719 157.702 580.739 152.043C577.759 146.385 570.468 143.717 564.87 146.237C559.272 148.756 557.046 155.707 560.026 161.366Z",
    fill: "url(#paint177_linear_78_4792)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M402.306 309.493C398.73 302.703 401.348 294.524 408.196 291.092C415.045 287.66 423.921 291.364 427.497 298.155C431.073 304.945 428.324 313.532 421.606 316.555C414.889 319.579 406.311 316.44 402.306 309.493ZM404.545 308.485C407.525 314.144 414.816 316.812 420.414 314.292C426.012 311.772 428.238 304.821 425.258 299.162C422.278 293.504 414.986 290.836 409.388 293.355C403.79 295.875 401.565 302.826 404.545 308.485Z",
    fill: "url(#paint178_linear_78_4792)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M550.313 236.658C546.737 229.869 549.486 221.283 556.202 218.26C562.919 215.237 571.924 218.532 575.5 225.322C579.075 232.111 576.458 240.287 569.61 243.719C562.894 246.742 554.317 243.604 550.313 236.658ZM552.552 235.65C555.531 241.308 562.821 243.975 568.418 241.456C574.016 238.937 576.241 231.987 573.261 226.329C570.282 220.672 562.991 218.004 557.394 220.523C551.797 223.042 549.572 229.993 552.552 235.65Z",
    fill: "url(#paint179_linear_78_4792)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M420.729 219.604C417.451 213.38 420.105 206.587 425.702 204.068C431.859 201.297 439.018 204.373 441.998 210.031C445.275 216.254 442.621 223.048 437.024 225.567C431.427 228.086 423.577 225.67 420.729 219.604ZM422.408 218.848C425.089 223.94 431.093 226.137 435.702 223.712C440.739 221.445 442.571 215.722 439.759 211.039C437.077 205.947 431.074 203.75 426.465 206.174C421.856 208.598 419.595 214.165 422.277 219.257L422.408 218.848Z",
    fill: "url(#paint180_linear_78_4792)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M374.489 71.4906C371.642 65.4266 373.866 58.479 379.461 55.9608C385.485 53.5995 392.772 56.2661 395.75 61.9214C399.027 68.1423 396.803 75.0899 390.779 77.4513C384.755 79.8126 377.468 77.146 374.489 71.4906ZM376.168 70.7351C378.848 75.8249 384.85 78.0209 389.885 75.7545C394.921 73.4882 396.753 67.7667 394.072 62.6768C391.391 57.587 385.39 55.391 380.354 57.6574C375.319 59.9238 373.487 65.6452 376.168 70.7351Z",
    fill: "url(#paint181_linear_78_4792)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M488.817 13.2585C485.838 7.60308 487.765 0.089955 493.788 -2.27139C499.812 -4.63274 507.1 -1.96615 510.078 3.68923C513.354 9.91015 511.13 16.8577 505.106 19.2191C499.381 22.146 491.795 18.9138 488.817 13.2585ZM490.495 12.5029C493.176 17.5927 499.177 19.7887 503.784 17.3655C508.82 15.0991 510.651 9.37761 507.971 4.28777C505.29 -0.802077 499.158 -2.58942 494.253 -0.731709C489.348 1.126 487.386 7.25624 490.197 11.9374L490.495 12.5029Z",
    fill: "url(#paint182_linear_78_4792)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M443.001 81.7084C437.936 72.0917 441.47 61.0543 450.853 57.181C460.367 52.8989 471.944 57.1352 476.58 66.5951C481.645 76.2118 478.111 87.2492 468.728 91.1225C459.345 94.9958 447.637 91.1682 443.001 81.7084ZM445.799 80.449C449.97 88.3686 459.403 91.8204 467.238 88.294C475.073 84.7676 477.952 75.7742 473.782 67.8546C469.611 59.9349 460.177 56.4831 452.342 60.0096C444.507 63.536 441.628 72.5293 445.799 80.449Z",
    fill: "url(#paint183_linear_78_4792)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M397.206 190.83C392.142 181.215 395.675 170.181 405.056 166.308C414.567 162.027 426.011 166.671 430.777 175.72C435.84 185.334 432.308 196.369 422.927 200.241C413.546 204.114 401.971 199.878 397.206 190.83ZM400.003 189.57C404.173 197.488 413.604 200.939 421.437 197.413C429.271 193.888 432.149 184.897 427.979 176.979C423.809 169.061 414.378 165.61 406.545 169.136C398.712 172.662 395.833 181.653 400.003 189.57Z",
    fill: "url(#paint184_linear_78_4792)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1340.63 774.963H1212.7L1122.43 867.101L1030.79 867.101L945.058 779.617L649.286 779.617L579.88 850.349H481.895V855.002H581.694L651.101 784.27L943.243 784.27L1028.98 872.219L1124.24 872.219L1214.52 779.617H1340.63V774.963Z",
    fill: "url(#paint185_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.626 710.746L459.665 710.746L424.281 747.043H279.117V752.162H426.095L461.479 715.865L658.358 715.865L779.479 839.646L963.655 839.646L1047.58 925.734H1270.77L1307.97 887.11L1345.16 887.11V882.457L1306.15 882.457L1268.95 920.615H1049.39L965.47 834.527L781.293 834.527L660.626 710.746Z",
    fill: "url(#paint186_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.15 420.374H999.039L915.116 506.927H808.058L570.806 750.3H483.254V754.954H572.62L809.872 511.581H916.931L1000.85 425.493H1081.15V420.374Z",
    fill: "url(#paint187_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.86 690.737H1062.55L1014.46 739.597L752.262 739.597V749.37L1018.55 749.37L1066.63 700.509H1178.23L1239.01 762.864H1345.16V753.092H1243.1L1181.86 690.737Z",
    fill: "url(#paint188_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.636 600.461H784.016V605.114H971.368L1030.34 665.608H1235.84L1273.94 704.697H1352.88V700.044H1275.76L1237.65 660.955L1032.61 660.49L973.636 600.461Z",
    fill: "url(#paint189_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.91 511.115H1023.99L844.802 694.925H728.671L642.48 606.51L360.318 606.51L312.233 557.649H244.641V567.422H308.603L356.689 616.282L638.851 616.282L724.588 704.697H848.885L1028.07 520.422H1104.28L1142.39 559.976L1351.51 559.976V550.204L1146.47 550.204L1107.91 511.115Z",
    fill: "url(#paint190_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.493 534.382L689.659 534.382L547.671 680.034H382.547L383.001 689.806H551.3L693.742 543.689L995.864 543.689L1062.09 612.094H1345.16V602.322H1066.18L999.493 534.382Z",
    fill: "url(#paint191_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.977 500.412H244.641V505.066H347.163L417.023 576.728L618.891 576.728V572.075L419.291 572.075L348.977 500.412Z",
    fill: "url(#paint192_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.12 301.712L916.477 301.712L814.409 406.879L630.232 406.879L558.104 480.868H485.068V485.521H559.918L632.047 411.532L816.223 411.532L918.291 306.831L1274.85 306.831L1339.72 372.909H1362.4V368.256H1341.53L1277.12 301.712Z",
    fill: "url(#paint193_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.24 172.813L913.303 172.813L882.002 204.921L716.878 204.921L501.4 425.958L210.619 425.958L167.524 381.751L163.895 385.008L208.805 431.077L503.215 431.077L718.692 210.04L883.816 210.04L915.117 177.466L1215.42 177.931L1239.01 202.129L1357.87 202.129V197.01L1240.83 197.01L1217.24 172.813Z",
    fill: "url(#paint194_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.875 377.562L423.828 377.562V382.681L671.06 382.681L762.241 476.215L1089.31 476.215L1193.2 582.778H1352.88V577.659H1195.01L1091.58 471.096L764.509 471.096L672.875 377.562Z",
    fill: "url(#paint195_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.42 852.21C491.42 846.626 487.337 842.438 481.894 842.438C476.45 842.438 472.367 846.626 472.367 852.21C472.367 857.794 476.45 861.982 481.894 861.982C487.337 861.982 491.42 857.794 491.42 852.21Z",
    fill: "url(#paint196_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.596 750.3C494.596 745.182 490.513 740.528 485.069 740.528C479.626 740.528 475.543 744.716 475.543 750.3C475.543 755.884 479.626 760.073 485.069 760.073C490.513 760.073 494.596 755.884 494.596 750.3Z",
    fill: "url(#paint197_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.529 502.739C255.529 497.62 251.447 492.967 246.003 492.967C240.559 492.967 236.477 497.155 236.477 502.739C236.477 508.323 240.559 512.511 246.003 512.511C251.447 512.511 255.529 508.323 255.529 502.739Z",
    fill: "url(#paint198_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.965 574.402C627.965 568.818 623.882 564.63 618.438 564.63C612.995 564.63 608.912 568.818 608.912 574.402C608.912 579.986 612.995 584.174 618.438 584.174C623.882 584.174 627.965 579.986 627.965 574.402Z",
    fill: "url(#paint199_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.957 484.126C495.957 478.542 491.874 474.353 486.431 474.353C480.987 474.353 476.904 478.542 476.904 484.126C476.904 489.71 480.987 493.898 486.431 493.898C491.874 493.898 495.957 489.71 495.957 484.126Z",
    fill: "url(#paint200_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.195 425.958C513.195 420.839 509.113 416.186 503.669 416.186C498.225 416.186 494.143 420.374 494.143 425.958C494.143 431.542 498.225 435.73 503.669 435.73C509.113 435.73 513.195 431.542 513.195 425.958Z",
    fill: "url(#paint201_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.719 781.944C659.719 776.36 655.636 772.172 650.192 772.172C644.749 772.172 640.666 776.36 640.666 781.944C640.666 787.528 644.749 791.716 650.192 791.716C655.636 791.716 659.719 787.528 659.719 781.944Z",
    fill: "url(#paint202_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.996 604.183C793.996 598.599 789.913 594.411 784.47 594.411C779.026 594.411 774.943 598.599 774.943 604.183C774.943 609.302 779.026 613.956 784.47 613.956C789.913 613.956 793.996 609.768 793.996 604.183Z",
    fill: "url(#paint203_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.75 409.671C825.75 404.087 821.667 399.899 816.224 399.899C810.78 399.899 806.697 404.087 806.697 409.671C806.697 414.79 810.78 419.443 816.224 419.443C821.667 419.443 825.75 415.255 825.75 409.671Z",
    fill: "url(#paint204_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.967 382.681C172.967 377.097 168.884 372.909 163.44 372.909C157.997 372.909 153.914 377.097 153.914 382.681C153.914 388.265 157.997 392.453 163.44 392.453C168.884 392.453 172.967 388.265 172.967 382.681Z",
    fill: "url(#paint205_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.715 380.82C434.715 375.701 430.632 371.048 425.189 371.048C419.745 371.048 415.662 375.236 415.662 380.82C415.662 385.939 419.745 390.592 425.189 390.592C430.632 390.592 434.715 386.404 434.715 380.82Z",
    fill: "url(#paint206_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.674 473.423C772.674 467.839 768.591 463.651 763.147 463.651C757.704 463.651 753.621 467.839 753.621 473.423C753.621 479.007 757.704 483.195 763.147 483.195C768.591 483.195 772.674 479.007 772.674 473.423Z",
    fill: "url(#paint207_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.912 837.319C789.912 831.735 785.829 827.547 780.386 827.547C774.942 827.547 770.859 831.735 770.859 837.319C770.859 842.438 774.942 847.091 780.386 847.091C785.376 847.091 789.912 842.903 789.912 837.319Z",
    fill: "url(#paint208_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.912 749.37C290.912 743.786 286.829 739.598 281.386 739.598C275.942 739.598 271.859 743.786 271.859 749.37C271.859 754.954 275.942 759.142 281.386 759.142C286.829 759.142 290.912 754.954 290.912 749.37Z",
    fill: "url(#paint209_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.063 685.153C397.063 677.707 391.166 671.658 383.907 671.658C376.649 671.658 370.752 677.707 370.752 685.153C370.752 692.598 376.649 698.648 383.907 698.648C391.166 698.648 397.063 692.598 397.063 685.153Z",
    fill: "url(#paint210_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.778 744.251C766.778 736.805 760.881 730.756 753.623 730.756C746.365 730.756 740.014 736.805 740.014 744.251C740.014 751.696 745.911 757.746 753.623 757.746C761.335 757.746 766.778 751.696 766.778 744.251Z",
    fill: "url(#paint211_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.983 561.372C255.983 553.927 250.085 547.877 242.827 547.877C235.569 547.877 229.672 553.927 229.672 561.372C229.672 568.818 235.569 574.867 242.827 574.867C250.085 574.867 255.983 568.818 255.983 561.372Z",
    fill: "url(#paint212_linear_78_4792)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.546 796.834H824.842V800.557H879.732L926.457 849.418L1029.89 849.418L1049.85 869.893H1139.67L1192.29 815.448L1190.02 813.121L1138.3 866.17H1051.21L1031.25 845.695L927.817 845.695L881.546 796.834Z",
    fill: "url(#paint213_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.66 723.311H1094.3L1027.62 791.716H960.027L896.517 726.568L677.411 726.568L626.603 779.152H554.021V782.874H627.964L679.225 730.291L895.156 730.291L958.212 794.973H1028.98L1095.66 727.033H1188.66V723.311Z",
    fill: "url(#paint214_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.029 675.846L537.236 675.846L511.379 702.836H403.867V706.093H512.74L539.051 679.569L684.668 679.569L774.035 771.241H910.126L972.274 834.992H1137.4L1165.07 806.141H1192.29V802.884H1163.26L1135.58 831.269H973.635L911.487 767.518L775.396 767.518L686.029 675.846Z",
    fill: "url(#paint215_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.77 461.324H936.436L874.288 525.075H794.902L619.344 705.162H554.928V708.885H620.705L796.263 528.798H875.649L937.797 464.581H996.77V461.324Z",
    fill: "url(#paint216_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.62 660.955H983.161L947.778 697.251L754.075 697.251L753.621 704.697L950.499 704.697L986.337 667.935H1068.9L1113.81 714.469H1192.29V707.023H1116.98L1071.62 660.955Z",
    fill: "url(#paint217_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.385 594.411H777.211V597.669H916.024L959.573 642.341H1111.54L1139.67 671.658H1198.19V667.935H1141.03L1112.9 639.084L960.934 639.084L917.385 594.411Z",
    fill: "url(#paint218_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.18 527.868H955.036L822.12 664.212H736.383L672.874 599.065L463.747 599.065L428.363 562.768H378.01V569.748H425.642L461.025 606.045L669.698 606.045L733.661 671.658H825.296L957.758 535.313H1014.01L1042.59 564.164H1196.82V557.184H1045.31L1017.18 527.868Z",
    fill: "url(#paint219_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.89 545.085H707.803L602.56 653.044H480.531V660.489H605.281L710.525 552.53H933.715L983.161 602.787L1192.29 602.787V595.807H985.883L936.89 545.085Z",
    fill: "url(#paint220_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.582 519.957H378.01V523.679H454.221L505.935 576.728L655.182 576.728V573.471L507.296 573.471L455.582 519.957Z",
    fill: "url(#paint221_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.93 373.374L875.196 373.374L799.892 451.086H663.347L610.272 505.996H556.289V509.254H611.633L665.162 454.809H801.253L876.557 377.097L1140.57 377.097L1188.21 425.958H1204.99V422.235H1189.57L1141.93 373.374Z",
    fill: "url(#paint222_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.93 277.98L872.928 277.98L849.792 301.712L727.764 301.712L568.084 465.512L353.514 465.512L321.305 432.473L319.037 434.799L351.699 468.769L569.898 468.769L729.125 305.435L851.153 305.435L874.289 281.702L1096.12 281.702L1113.81 299.385L1201.81 299.385V296.128L1115.17 296.128L1097.93 277.98Z",
    fill: "url(#paint223_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.102 429.681L510.926 429.681V432.938L693.741 432.938L761.333 502.274L1003.12 502.274L1079.79 580.916H1198.19V577.659H1081.6L1004.94 498.551L762.694 498.551L695.102 429.681Z",
    fill: "url(#paint224_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.648 798.696C831.648 794.973 828.472 791.25 824.843 791.716C821.214 791.716 817.585 794.973 818.039 798.696C818.039 802.419 821.214 805.676 824.843 805.676C828.472 805.676 831.648 802.419 831.648 798.696Z",
    fill: "url(#paint225_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.826 780.547C560.826 776.359 557.65 773.567 554.021 773.567C550.392 773.567 547.217 776.825 547.217 780.547C547.217 784.27 550.392 787.528 554.021 787.528C557.65 787.528 560.826 784.27 560.826 780.547Z",
    fill: "url(#paint226_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.093 705.162C563.093 701.439 559.918 698.182 556.289 698.182C552.66 698.182 549.484 701.439 549.484 705.162C549.484 708.885 552.66 712.142 556.289 712.142C559.918 712.142 563.093 708.885 563.093 705.162Z",
    fill: "url(#paint227_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.175 521.818C386.175 518.096 383 514.838 379.371 514.838C375.742 514.838 372.566 518.096 372.566 521.818C372.566 526.006 375.742 528.798 379.371 528.798C383 528.798 386.175 525.541 386.175 521.818Z",
    fill: "url(#paint228_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.986 575.332C661.986 571.144 658.811 568.352 655.182 567.887C651.099 567.887 648.377 571.144 648.377 575.332C648.377 579.52 651.552 582.312 655.182 582.312C658.811 582.312 661.986 579.055 661.986 575.332Z",
    fill: "url(#paint229_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.455 508.323C564.455 504.135 561.279 501.343 557.65 501.343C554.021 501.343 550.846 504.6 550.846 508.323C550.846 512.511 554.021 515.303 557.65 515.303C561.279 515.303 564.455 512.046 564.455 508.323Z",
    fill: "url(#paint230_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.157 465.512C577.157 461.324 573.981 458.532 570.352 458.532C566.723 458.532 563.094 461.789 563.094 465.512C563.094 469.235 566.269 472.492 570.352 472.492C574.435 472.492 577.157 469.235 577.157 465.512Z",
    fill: "url(#paint231_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.121 728.429C685.121 724.241 681.946 721.449 678.317 721.449C674.688 721.449 671.512 724.707 671.059 728.429C671.059 732.152 674.234 735.41 678.317 735.41C682.4 735.41 685.121 732.152 685.121 728.429Z",
    fill: "url(#paint232_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.468 597.203C784.468 593.481 781.293 590.223 777.664 590.223C774.035 590.223 770.859 593.481 770.859 597.203C770.859 601.391 774.035 604.183 777.664 604.183C781.293 604.183 784.468 600.926 784.468 597.203Z",
    fill: "url(#paint233_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.058 452.948C808.058 449.225 804.883 445.968 801.254 445.968C797.625 445.968 794.449 449.225 794.449 452.948C794.449 456.67 797.625 459.928 801.254 459.928C804.883 459.928 808.058 456.67 808.058 452.948Z",
    fill: "url(#paint234_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.388 432.938C325.388 429.215 322.213 425.958 318.584 425.958C314.955 425.958 311.779 429.215 311.779 432.938C311.779 437.126 314.955 439.918 318.584 439.918C322.213 439.918 325.388 436.661 325.388 432.938Z",
    fill: "url(#paint235_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.092 432.007C519.092 428.285 515.916 425.027 512.287 425.027C508.658 425.027 505.482 428.285 505.482 432.007C505.482 436.195 508.658 438.987 512.287 438.987C515.916 438.987 519.092 435.73 519.092 432.007Z",
    fill: "url(#paint236_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.045 500.412C769.045 496.69 765.87 493.432 762.241 493.432C758.612 493.432 754.982 496.69 754.982 500.878C754.982 505.066 758.158 507.858 761.787 507.858C765.416 507.858 768.592 504.6 768.592 500.878L769.045 500.412Z",
    fill: "url(#paint237_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.293 769.379C781.293 765.657 778.117 762.399 774.488 762.399C770.859 762.399 767.684 765.657 767.684 769.379C767.684 773.102 770.859 776.36 774.488 776.36C778.117 776.36 781.746 773.102 781.746 769.379H781.293Z",
    fill: "url(#paint238_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.486 704.697C412.486 700.509 409.311 697.251 405.681 697.717C402.052 697.717 398.877 700.974 398.877 704.697C398.877 708.42 402.052 711.677 405.681 711.677C409.311 711.677 412.486 708.42 412.486 704.697Z",
    fill: "url(#paint239_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.966 656.767C490.966 651.183 486.43 646.529 480.986 646.529C475.542 646.529 471.006 651.183 471.006 656.767C471.006 662.351 475.542 667.004 480.986 667.004C486.43 667.004 490.966 662.351 490.966 656.767Z",
    fill: "url(#paint240_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.509 700.509C764.509 694.925 759.973 690.271 754.529 690.271C749.085 690.271 744.549 694.925 744.549 700.509C744.549 706.093 749.085 710.281 754.529 710.281C759.973 710.281 764.509 705.628 764.509 700.043V700.509Z",
    fill: "url(#paint241_linear_78_4792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.083 565.56C387.083 559.976 382.547 555.323 377.103 555.323C371.659 555.323 367.123 559.976 367.123 565.56C367.123 571.144 371.659 575.798 377.103 575.798C382.547 575.798 387.083 571.144 387.083 565.56Z",
    fill: "url(#paint242_linear_78_4792)"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M865.671 768.914H816.225V772.172H864.764L905.137 814.983H995.411L1012.65 832.666H1091.13L1137.4 785.201L1135.13 782.874L1089.77 829.408H1014.01L996.772 811.725L906.498 811.725L865.671 768.914Z",
    fill: "url(#paint243_linear_78_4792)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.22 704.697L1051.66 704.697L993.596 764.261H934.169L878.826 707.489L687.844 707.489L642.934 753.558H579.879V756.35H644.295L689.205 710.747L877.918 710.747L933.262 767.518H994.503L1053.02 707.955L1134.22 707.955V704.697Z",
    fill: "url(#paint244_linear_78_4792)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M695.102 663.282L565.362 663.282L542.68 686.549H448.777V689.806H544.041L566.723 666.539L693.741 666.539L771.767 746.112H891.073L945.056 801.953L1089.31 801.953L1113.36 777.29H1137.4V774.033H1111.99L1087.95 798.696L946.417 798.696L891.981 743.32H773.128L695.102 663.282Z",
    fill: "url(#paint245_linear_78_4792)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M966.83 475.749H913.755L859.318 531.59L790.365 531.59L637.036 688.875H580.785V691.667H638.397L791.726 534.848L860.679 534.848L915.116 479.007H966.83V475.749Z",
    fill: "url(#paint246_linear_78_4792)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.7 650.252H954.583L923.736 681.895H754.529V688.41H926.458L957.305 656.302H1029.43L1068.9 696.786H1137.4V690.737H1071.17L1031.7 650.252Z",
    fill: "url(#paint247_linear_78_4792)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M897.425 592.085H774.943V594.877H896.064L934.17 633.965L1066.63 633.965L1091.13 659.559H1142.39V656.302H1092.49L1067.99 631.173L935.531 630.708L897.425 592.085Z",
    fill: "url(#paint248_linear_78_4792)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M984.071 534.382H930.088L813.957 653.044H739.107L683.763 596.273L501.401 596.273L470.554 564.164H426.551V570.679H467.832L498.679 602.322L681.041 602.322L736.838 659.559H816.678L932.356 540.432H981.802L1006.3 566.025H1141.48V559.511H1009.02L984.071 534.382Z",
    fill: "url(#paint249_linear_78_4792)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M914.209 549.273H714.155L622.067 643.272H515.916V649.787H624.789L716.423 555.323H911.487L954.583 599.53L1137.4 599.53V593.015L956.851 593.015L914.209 549.273Z",
    fill: "url(#paint250_linear_78_4792)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M494.143 527.402H426.551V530.66H492.782L538.145 576.728L667.886 576.728V573.471L539.506 573.471L494.143 527.402Z",
    fill: "url(#paint251_linear_78_4792)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.4 399.434L860.68 399.434L794.449 466.908L675.596 466.908L628.872 514.838H581.693V518.095H630.232L676.957 470.165L795.81 470.165L861.587 402.226L1092.03 402.226L1133.77 445.037H1148.29V441.78H1134.68L1093.4 399.434Z",
    fill: "url(#paint252_linear_78_4792)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.84 315.672L858.411 315.672L837.998 336.613H731.393L592.58 479.472L404.775 479.472L376.649 450.621L374.381 452.948L403.414 482.729L593.488 482.264L732.754 339.87H839.359L859.772 318.93L1053.48 318.93L1068.45 334.751H1145.56V331.494H1069.81L1054.84 315.672Z",
    fill: "url(#paint253_linear_78_4792)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M703.268 448.294L542.227 448.294V451.086L701.907 451.086L760.88 511.581L972.274 511.581L1038.96 580.451L1142.39 580.451V577.194L1040.32 577.194L973.182 508.789L762.24 508.789L703.268 448.294Z",
    fill: "url(#paint254_linear_78_4792)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M822.576 770.776C822.576 767.518 819.854 764.726 816.678 764.726C813.503 764.726 810.781 767.518 810.781 770.776C810.781 774.033 813.503 776.825 816.678 776.825C819.854 776.825 822.576 774.033 822.576 770.776Z",
    fill: "url(#paint255_linear_78_4792)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M585.777 754.488C585.777 751.231 583.055 748.439 579.88 748.439C576.704 748.439 573.982 751.231 573.982 754.488C573.982 757.746 576.704 760.538 579.88 760.538C583.055 760.538 586.231 757.746 585.777 754.488Z",
    fill: "url(#paint256_linear_78_4792)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M588.044 688.875C588.044 685.618 585.323 682.826 582.147 682.826C578.972 682.826 576.25 685.618 576.25 688.875C576.25 692.133 578.972 694.925 582.147 694.925C585.323 694.925 588.044 692.133 588.044 688.875Z",
    fill: "url(#paint257_linear_78_4792)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M433.355 528.798C433.355 525.541 430.633 522.749 427.458 522.749C424.282 522.749 421.561 525.541 421.561 528.798C421.561 532.521 424.282 534.848 427.911 534.848C431.541 534.848 433.809 532.056 433.809 528.798H433.355Z",
    fill: "url(#paint258_linear_78_4792)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M674.236 575.332C674.236 571.61 671.514 568.818 668.339 569.283C665.163 569.283 662.441 572.075 662.441 575.332C662.441 578.59 665.163 581.382 668.339 581.382C671.514 581.382 674.236 578.59 674.236 575.332Z",
    fill: "url(#paint259_linear_78_4792)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M588.953 516.699C588.953 512.977 586.231 510.65 583.056 510.65C579.88 510.65 577.158 513.442 577.158 516.699C577.158 519.957 579.88 522.749 583.056 522.749C586.231 522.749 588.953 519.957 588.953 516.699Z",
    fill: "url(#paint260_linear_78_4792)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M599.84 479.472C599.84 476.215 597.118 473.423 593.942 473.423C590.767 473.423 588.045 476.215 588.045 479.472C588.045 482.73 590.767 485.522 593.942 485.522C597.118 485.522 599.84 482.73 599.84 479.472Z",
    fill: "url(#paint261_linear_78_4792)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M694.65 709.35C694.65 705.628 691.928 703.301 688.753 703.301C685.577 703.301 682.855 706.093 682.855 709.35C682.855 712.608 685.577 715.4 688.753 715.4C691.928 715.4 695.104 712.608 695.104 709.35H694.65Z",
    fill: "url(#paint262_linear_78_4792)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M781.295 594.411C781.295 591.154 778.573 588.362 775.397 588.362C772.222 588.362 769.5 591.154 769.5 594.411C769.5 597.669 772.222 600.461 775.397 600.461C778.573 600.461 781.295 597.669 781.295 594.411Z",
    fill: "url(#paint263_linear_78_4792)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M801.707 468.769C801.707 465.512 798.985 462.72 795.809 462.72C792.634 462.72 789.912 465.512 789.912 468.769C789.912 472.027 792.634 474.819 795.809 474.819C799.439 474.819 802.16 472.027 801.707 468.769Z",
    fill: "url(#paint264_linear_78_4792)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M380.279 451.086C380.279 447.829 377.557 445.037 374.382 445.037C371.206 445.037 368.484 447.829 368.484 451.086C368.484 454.344 371.206 457.136 374.382 457.136C377.557 457.136 380.279 454.344 380.279 451.086Z",
    fill: "url(#paint265_linear_78_4792)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M549.486 450.156C549.486 446.898 546.764 444.106 543.589 444.106C540.413 444.106 537.691 446.898 537.691 450.156C537.691 453.413 540.413 456.205 543.589 456.205C546.764 456.205 549.486 453.413 549.486 450.156Z",
    fill: "url(#paint266_linear_78_4792)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M767.685 510.185C767.685 506.927 764.963 504.135 761.788 504.135C758.612 504.135 755.891 506.927 755.891 510.185C755.891 513.442 758.612 516.234 762.242 516.234C765.871 516.234 768.139 513.442 768.139 510.185H767.685Z",
    fill: "url(#paint267_linear_78_4792)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M778.572 744.716C778.572 741.459 775.85 738.667 772.675 738.667C769.499 738.667 766.777 741.459 766.777 744.716C766.777 747.974 769.499 750.766 772.675 750.766C775.85 750.766 778.572 747.974 778.572 744.716Z",
    fill: "url(#paint268_linear_78_4792)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M456.49 688.41C456.49 685.153 453.768 682.361 450.593 682.361C447.417 682.361 444.695 685.153 444.695 688.41C444.695 691.668 447.417 694.46 450.593 694.46C453.768 694.46 456.49 691.668 456.49 688.41Z",
    fill: "url(#paint269_linear_78_4792)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M524.988 646.529C524.988 641.411 521.359 637.688 516.369 637.688C511.379 637.688 507.75 641.411 507.75 646.529C507.75 651.648 511.833 655.371 516.369 655.371C520.905 655.371 524.988 651.648 524.988 646.529Z",
    fill: "url(#paint270_linear_78_4792)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M763.602 684.688C763.602 679.569 759.972 675.846 754.982 675.846C749.992 675.846 746.363 679.569 746.363 684.688C746.363 689.806 749.992 693.529 754.982 693.529C759.972 693.529 763.602 689.806 763.602 684.688Z",
    fill: "url(#paint271_linear_78_4792)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M433.809 566.956C433.809 561.838 430.18 558.115 425.19 558.115C420.2 558.115 416.57 561.838 416.57 566.956C416.57 572.075 420.2 575.798 425.19 575.798C430.18 575.798 433.809 571.61 433.809 566.956Z",
    fill: "url(#paint272_linear_78_4792)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M817.132 756.815C824.843 756.815 831.648 763.33 831.648 771.706C831.648 780.082 825.297 786.597 817.132 786.597C808.966 786.597 802.615 780.082 802.615 771.706C802.615 763.33 808.966 756.815 817.132 756.815ZM817.132 783.805C823.483 783.805 828.926 778.221 828.926 771.706C828.926 765.191 823.483 759.607 817.132 759.607C810.781 759.607 805.337 765.191 805.337 771.706C805.337 778.221 810.781 783.805 817.132 783.805Z",
    fill: "url(#paint273_linear_78_4792)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M580.333 740.993C588.045 740.993 594.849 747.508 594.849 755.884C594.849 764.261 588.498 770.775 580.333 770.775C572.167 770.775 565.816 764.261 565.816 755.884C565.816 747.508 572.167 740.993 580.333 740.993ZM580.333 767.983C587.137 767.983 592.127 762.399 592.127 755.884C592.127 749.37 586.684 743.786 580.333 743.786C573.982 743.786 568.538 749.37 568.538 755.884C568.538 762.399 573.982 767.983 580.333 767.983Z",
    fill: "url(#paint274_linear_78_4792)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M581.694 501.808C589.406 501.808 596.21 508.323 596.21 516.699C596.21 525.075 589.86 531.59 581.694 531.59C573.529 531.59 567.178 525.075 567.178 516.699C567.178 508.323 573.529 501.808 581.694 501.808ZM581.694 528.798C588.045 528.798 593.489 523.214 593.489 516.699C593.489 510.185 588.045 504.6 581.694 504.6C575.343 504.6 569.9 510.185 569.9 516.699C569.9 523.214 575.343 528.798 581.694 528.798Z",
    fill: "url(#paint275_linear_78_4792)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M373.473 437.591C381.185 437.591 387.99 444.106 387.99 452.482C387.99 460.858 381.639 467.373 373.473 467.373C365.308 467.373 358.957 460.858 358.957 452.482C358.957 444.106 365.308 437.591 373.473 437.591ZM373.473 464.581C380.278 464.581 385.268 458.997 385.268 452.482C385.268 445.968 379.824 440.383 373.473 440.383C367.122 440.383 361.679 445.968 361.679 452.482C361.679 458.997 367.122 464.581 373.473 464.581Z",
    fill: "url(#paint276_linear_78_4792)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M542.227 435.73C550.393 435.73 556.744 442.245 556.744 450.621C556.744 458.997 550.393 465.512 542.227 465.512C534.062 465.512 527.711 458.997 527.711 450.621C527.711 442.245 534.062 435.73 542.227 435.73ZM542.227 462.72C548.578 462.72 554.022 457.136 554.022 450.621C554.022 444.106 548.578 438.522 542.227 438.522C535.876 438.522 530.433 444.106 530.433 450.621C530.433 457.136 535.876 462.72 542.227 462.72Z",
    fill: "url(#paint277_linear_78_4792)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M427.91 515.769C434.715 515.769 440.159 521.353 440.159 528.333C440.159 535.313 434.715 540.897 427.91 540.897C421.106 540.897 415.662 535.313 415.662 528.333C415.662 521.353 421.106 515.769 427.91 515.769ZM427.91 538.57C433.354 538.57 437.89 533.917 437.89 528.333C437.89 522.749 433.354 518.095 427.91 518.095C422.467 518.095 417.93 522.749 417.93 528.333C417.93 533.917 422.467 538.57 427.91 538.57Z",
    fill: "url(#paint278_linear_78_4792)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M450.139 676.311C456.943 676.311 462.387 681.895 462.387 688.875C462.387 695.855 456.943 701.44 450.139 701.44C443.334 701.44 437.891 695.855 437.891 688.875C437.891 681.895 443.334 676.311 450.139 676.311ZM450.139 699.113C455.582 699.113 460.119 694.459 460.119 688.875C460.119 683.291 455.582 678.638 450.139 678.638C444.695 678.638 440.159 683.291 440.159 688.875C440.159 694.459 444.695 699.113 450.139 699.113Z",
    fill: "url(#paint279_linear_78_4792)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M581.24 676.776C588.045 676.776 593.489 682.36 593.489 689.341C593.489 696.321 588.045 701.905 581.24 701.905C574.436 701.905 568.992 696.321 568.992 689.341C568.992 682.36 574.436 676.776 581.24 676.776ZM581.24 699.578C586.684 699.578 591.22 694.925 591.22 689.341C591.22 683.756 586.684 679.103 581.24 679.103C575.797 679.103 571.26 683.756 571.26 689.341C571.26 694.925 575.797 699.578 581.24 699.578Z",
    fill: "url(#paint280_linear_78_4792)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M755.436 663.747C766.323 663.747 774.942 672.589 774.942 683.757C774.942 694.925 766.323 703.766 755.436 703.766C744.549 703.766 735.93 694.925 735.93 683.757C735.93 672.589 744.549 663.747 754.982 663.747H755.436ZM755.436 700.044C764.055 700.044 771.313 692.598 771.313 683.757C771.313 674.915 764.055 667.47 755.436 667.47C746.817 667.47 739.559 674.915 739.559 683.757C739.559 692.598 746.817 700.044 755.436 700.044Z",
    fill: "url(#paint281_linear_78_4792)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M515.916 626.985C526.349 626.985 535.422 635.827 535.422 646.995C535.422 658.163 526.803 667.005 515.916 667.005C505.028 667.005 496.409 658.163 496.863 646.995C496.863 636.292 505.482 626.985 515.916 626.985ZM515.916 663.282C524.535 663.282 531.793 655.836 531.793 646.995C531.793 638.153 524.535 630.708 515.916 630.708C507.297 630.708 500.038 638.153 500.038 646.995C500.038 655.836 507.297 663.282 515.916 663.282Z",
    fill: "url(#paint282_linear_78_4792)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M426.096 546.016C436.529 546.016 445.602 554.857 445.602 566.025C445.602 577.194 436.983 586.035 426.549 586.035C416.116 586.035 407.043 577.194 407.043 566.025C407.043 554.857 415.662 546.016 426.549 546.016H426.096ZM426.096 582.312C434.715 582.312 441.973 574.867 441.973 566.025C441.973 557.184 434.715 549.739 426.096 549.739C417.477 549.739 410.218 557.184 410.218 566.025C410.218 574.867 417.477 582.312 426.096 582.312Z",
    fill: "url(#paint283_linear_78_4792)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_4792",
    x1: 63.6221,
    y1: 1144.03,
    x2: 1071.8,
    y2: 1650.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_4792",
    x1: 56.1994,
    y1: 1127.89,
    x2: 1080.78,
    y2: 1642.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_4792",
    x1: 170.286,
    y1: 926.949,
    x2: 1144.01,
    y2: 1426.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_78_4792",
    x1: 98.4084,
    y1: 1063.01,
    x2: 1114.9,
    y2: 1573.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_78_4792",
    x1: 115.988,
    y1: 993.056,
    x2: 1144.26,
    y2: 1509.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_78_4792",
    x1: 142.011,
    y1: 935.577,
    x2: 1156.29,
    y2: 1444.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_78_4792",
    x1: 148.906,
    y1: 945.998,
    x2: 1157.66,
    y2: 1452.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_78_4792",
    x1: 168.593,
    y1: 842.681,
    x2: 1198.25,
    y2: 1360.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_78_4792",
    x1: 237.298,
    y1: 750.702,
    x2: 1242.48,
    y2: 1255.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_78_4792",
    x1: 270.566,
    y1: 653.609,
    x2: 1273.73,
    y2: 1158.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_78_4792",
    x1: 183.799,
    y1: 820.944,
    x2: 1215.38,
    y2: 1339.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_78_4792",
    x1: 49.0231,
    y1: 1136.44,
    x2: 1063.11,
    y2: 1645.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_78_4792",
    x1: 88.728,
    y1: 1042.96,
    x2: 1104.07,
    y2: 1552.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_78_4792",
    x1: 186.475,
    y1: 797.015,
    x2: 1201.05,
    y2: 1306.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_78_4792",
    x1: 157.482,
    y1: 891.158,
    x2: 1173.2,
    y2: 1400.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_78_4792",
    x1: 193.768,
    y1: 798.169,
    x2: 1207.97,
    y2: 1307.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_78_4792",
    x1: 216.291,
    y1: 746.071,
    x2: 1231.44,
    y2: 1255.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_78_4792",
    x1: 76.2766,
    y1: 1084.47,
    x2: 1091.05,
    y2: 1593.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_78_4792",
    x1: 146.211,
    y1: 931.031,
    x2: 1160.99,
    y2: 1440.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_78_4792",
    x1: 223.028,
    y1: 754.537,
    x2: 1237.68,
    y2: 1263.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_78_4792",
    x1: 233.46,
    y1: 680.131,
    x2: 1247.51,
    y2: 1189.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_78_4792",
    x1: 234.442,
    y1: 698.456,
    x2: 1248.65,
    y2: 1207.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_78_4792",
    x1: 198.832,
    y1: 809.307,
    x2: 1211.65,
    y2: 1317.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_78_4792",
    x1: 89.44,
    y1: 1026.86,
    x2: 1103.64,
    y2: 1535.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_78_4792",
    x1: 114.401,
    y1: 975.349,
    x2: 1129.38,
    y2: 1484.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_78_4792",
    x1: 90.5299,
    y1: 1057.49,
    x2: 1106.74,
    y2: 1567.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_78_4792",
    x1: 162.962,
    y1: 850.872,
    x2: 1179.47,
    y2: 1360.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_78_4792",
    x1: 51.6566,
    y1: 1157.69,
    x2: 1069.91,
    y2: 1668.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_78_4792",
    x1: 89.0301,
    y1: 1081.98,
    x2: 1097.25,
    y2: 1588.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_78_4792",
    x1: 81.3916,
    y1: 1069.15,
    x2: 1105.98,
    y2: 1583.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_78_4792",
    x1: 171.58,
    y1: 923.754,
    x2: 1144.78,
    y2: 1423.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_78_4792",
    x1: 113.402,
    y1: 1021.66,
    x2: 1129.81,
    y2: 1531.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_78_4792",
    x1: 124.858,
    y1: 969.202,
    x2: 1153.06,
    y2: 1485.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_78_4792",
    x1: 145.844,
    y1: 927.115,
    x2: 1160.1,
    y2: 1436.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_78_4792",
    x1: 151.821,
    y1: 935.344,
    x2: 1160.56,
    y2: 1441.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_78_4792",
    x1: 163.518,
    y1: 857.763,
    x2: 1193.13,
    y2: 1375.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_78_4792",
    x1: 217.916,
    y1: 791.245,
    x2: 1222.63,
    y2: 1296.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_78_4792",
    x1: 242.324,
    y1: 719.16,
    x2: 1245.48,
    y2: 1223.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_78_4792",
    x1: 174.512,
    y1: 841.587,
    x2: 1206.23,
    y2: 1360.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_78_4792",
    x1: 77.2478,
    y1: 1075.8,
    x2: 1091.45,
    y2: 1584.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_78_4792",
    x1: 107.195,
    y1: 1006.72,
    x2: 1120.39,
    y2: 1515.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_78_4792",
    x1: 178.579,
    y1: 824.822,
    x2: 1193.92,
    y2: 1334.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_78_4792",
    x1: 158.181,
    y1: 894.851,
    x2: 1171.82,
    y2: 1403.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_78_4792",
    x1: 184.019,
    y1: 825.475,
    x2: 1198.79,
    y2: 1334.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_78_4792",
    x1: 201.446,
    y1: 787.294,
    x2: 1215.09,
    y2: 1295.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_78_4792",
    x1: 176.247,
    y1: 867.403,
    x2: 1191.02,
    y2: 1376.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_78_4792",
    x1: 97.702,
    y1: 1037.31,
    x2: 1112.03,
    y2: 1546.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_78_4792",
    x1: 148.63,
    y1: 924.027,
    x2: 1164.42,
    y2: 1433.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_78_4792",
    x1: 205.339,
    y1: 793.151,
    x2: 1220.69,
    y2: 1302.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_78_4792",
    x1: 213.511,
    y1: 738.435,
    x2: 1228.29,
    y2: 1247.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_78_4792",
    x1: 214.052,
    y1: 751.781,
    x2: 1228.83,
    y2: 1261.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_78_4792",
    x1: 187.122,
    y1: 833.61,
    x2: 1201.9,
    y2: 1342.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_78_4792",
    x1: 81.1961,
    y1: 1082.3,
    x2: 1096.42,
    y2: 1591.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_78_4792",
    x1: 97.2563,
    y1: 1053.87,
    x2: 1112.48,
    y2: 1563.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_78_4792",
    x1: 107.025,
    y1: 994.985,
    x2: 1121.23,
    y2: 1503.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_78_4792",
    x1: 125.851,
    y1: 956.796,
    x2: 1139.86,
    y2: 1465.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_78_4792",
    x1: 108.735,
    y1: 1017.71,
    x2: 1122.61,
    y2: 1526.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_78_4792",
    x1: 108.634,
    y1: 1031.64,
    x2: 1123.3,
    y2: 1541.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_78_4792",
    x1: 161.581,
    y1: 864.627,
    x2: 1176.02,
    y2: 1373.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_78_4792",
    x1: 65.0759,
    y1: 1125.45,
    x2: 1082.92,
    y2: 1636.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_78_4792",
    x1: 98.0768,
    y1: 1059.68,
    x2: 1106.15,
    y2: 1565.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_78_4792",
    x1: 90.0594,
    y1: 1047.76,
    x2: 1114.67,
    y2: 1562.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_78_4792",
    x1: 171.571,
    y1: 922.485,
    x2: 1145.33,
    y2: 1422.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_78_4792",
    x1: 119.13,
    y1: 1006.71,
    x2: 1135.46,
    y2: 1516.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_78_4792",
    x1: 128.033,
    y1: 960.44,
    x2: 1156.44,
    y2: 1477.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_78_4792",
    x1: 147.143,
    y1: 924.386,
    x2: 1161.43,
    y2: 1433.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_78_4792",
    x1: 152.849,
    y1: 931.527,
    x2: 1161.58,
    y2: 1438.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_78_4792",
    x1: 161.48,
    y1: 863.54,
    x2: 1191.16,
    y2: 1381.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_78_4792",
    x1: 210.802,
    y1: 805.724,
    x2: 1215.6,
    y2: 1311.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_78_4792",
    x1: 232.435,
    y1: 743.169,
    x2: 1235.6,
    y2: 1247.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_78_4792",
    x1: 171.074,
    y1: 849.208,
    x2: 1202.67,
    y2: 1367.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_78_4792",
    x1: 86.5761,
    y1: 1053.51,
    x2: 1103.06,
    y2: 1563.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_78_4792",
    x1: 113.236,
    y1: 993.701,
    x2: 1127.44,
    y2: 1502.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_78_4792",
    x1: 176.159,
    y1: 834.917,
    x2: 1189.8,
    y2: 1343.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_78_4792",
    x1: 157.602,
    y1: 895.593,
    x2: 1172.37,
    y2: 1404.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_78_4792",
    x1: 180.672,
    y1: 835.281,
    x2: 1195.57,
    y2: 1344.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_78_4792",
    x1: 196.028,
    y1: 801.803,
    x2: 1209.22,
    y2: 1310.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_78_4792",
    x1: 174.682,
    y1: 872.389,
    x2: 1188.2,
    y2: 1380.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_78_4792",
    x1: 105.792,
    y1: 1020.74,
    x2: 1118.85,
    y2: 1529.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_78_4792",
    x1: 150.119,
    y1: 921.242,
    x2: 1165.02,
    y2: 1430.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_78_4792",
    x1: 199.552,
    y1: 807.066,
    x2: 1214.33,
    y2: 1316.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_78_4792",
    x1: 206.712,
    y1: 759.431,
    x2: 1220.92,
    y2: 1268.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_78_4792",
    x1: 207.402,
    y1: 771.358,
    x2: 1221.04,
    y2: 1280.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_78_4792",
    x1: 183.691,
    y1: 842.48,
    x2: 1198.02,
    y2: 1351.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_78_4792",
    x1: 90.648,
    y1: 1059.33,
    x2: 1106,
    y2: 1568.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_78_4792",
    x1: 105.786,
    y1: 1035.04,
    x2: 1119.42,
    y2: 1543.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_78_4792",
    x1: 113.067,
    y1: 983.412,
    x2: 1128.29,
    y2: 1492.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_78_4792",
    x1: 129.098,
    y1: 949.731,
    x2: 1145.28,
    y2: 1459.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_78_4792",
    x1: 114.184,
    y1: 1002.88,
    x2: 1129.53,
    y2: 1512.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_78_4792",
    x1: 115.392,
    y1: 1015.86,
    x2: 1129.01,
    y2: 1524.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_78_4792",
    x1: 160.971,
    y1: 869.465,
    x2: 1175.75,
    y2: 1378.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_78_4792",
    x1: 80.0156,
    y1: 1072.72,
    x2: 1116.3,
    y2: 1570.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_78_4792",
    x1: 86.6727,
    y1: 1045.73,
    x2: 1122.38,
    y2: 1542.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_78_4792",
    x1: 181.094,
    y1: 825.748,
    x2: 1216.36,
    y2: 1323.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_78_4792",
    x1: 206.211,
    y1: 756.184,
    x2: 1241.33,
    y2: 1253.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_78_4792",
    x1: 206.801,
    y1: 762.689,
    x2: 1242.5,
    y2: 1259.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_78_4792",
    x1: 176.418,
    y1: 828.671,
    x2: 1211.54,
    y2: 1325.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_78_4792",
    x1: 113.239,
    y1: 977.604,
    x2: 1148.36,
    y2: 1474.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_78_4792",
    x1: 112.593,
    y1: 985.239,
    x2: 1148.55,
    y2: 1482.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_78_4792",
    x1: 114.866,
    y1: 997.68,
    x2: 1150.57,
    y2: 1494.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_78_4792",
    x1: 114.881,
    y1: 988.785,
    x2: 1150.59,
    y2: 1485.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_78_4792",
    x1: 129.809,
    y1: 942.262,
    x2: 1165.51,
    y2: 1439.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_78_4792",
    x1: 161.214,
    y1: 863.28,
    x2: 1196.92,
    y2: 1360.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_78_4792",
    x1: 102.454,
    y1: 10.5143,
    x2: 1216.48,
    y2: -606.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_78_4792",
    x1: 95.1093,
    y1: 26.9356,
    x2: 1228.77,
    y2: -600.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_78_4792",
    x1: 212.021,
    y1: 211.956,
    x2: 1282.62,
    y2: -397.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_78_4792",
    x1: 138.501,
    y1: 86.1386,
    x2: 1262.63,
    y2: -536.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_78_4792",
    x1: 156.991,
    y1: 151.977,
    x2: 1295.16,
    y2: -478.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_78_4792",
    x1: 183.726,
    y1: 206.649,
    x2: 1305.12,
    y2: -413.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_78_4792",
    x1: 190.565,
    y1: 196.181,
    x2: 1305.82,
    y2: -421.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_78_4792",
    x1: 211.385,
    y1: 295.581,
    x2: 1351.04,
    y2: -335.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_78_4792",
    x1: 282.066,
    y1: 377.585,
    x2: 1392.46,
    y2: -238.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_78_4792",
    x1: 316.515,
    y1: 469.719,
    x2: 1424.42,
    y2: -145.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_78_4792",
    x1: 227.147,
    y1: 313.864,
    x2: 1369.23,
    y2: -319.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_78_4792",
    x1: 128.036,
    y1: 108.216,
    x2: 1252.13,
    y2: -513.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_78_4792",
    x1: 229.67,
    y1: 339.58,
    x2: 1350.24,
    y2: -280.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_78_4792",
    x1: 200.813,
    y1: 248.843,
    x2: 1321.28,
    y2: -371.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_78_4792",
    x1: 236.758,
    y1: 336.826,
    x2: 1359.7,
    y2: -284.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_78_4792",
    x1: 260.088,
    y1: 385.394,
    x2: 1384.16,
    y2: -236.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_78_4792",
    x1: 187.45,
    y1: 211.222,
    x2: 1311.12,
    y2: -410.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_78_4792",
    x1: 267.491,
    y1: 375.639,
    x2: 1389.46,
    y2: -245.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_78_4792",
    x1: 278.449,
    y1: 448.902,
    x2: 1401.42,
    y2: -172.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_78_4792",
    x1: 279.431,
    y1: 430.112,
    x2: 1399.83,
    y2: -189.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_78_4792",
    x1: 242.536,
    y1: 324.351,
    x2: 1362.34,
    y2: -295.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_78_4792",
    x1: 128.74,
    y1: 124.539,
    x2: 1250.72,
    y2: -496.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_78_4792",
    x1: 155.052,
    y1: 172.172,
    x2: 1278.85,
    y2: -449.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_78_4792",
    x1: 205.455,
    y1: 288.935,
    x2: 1328.83,
    y2: -332.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_78_4792",
    x1: 128.646,
    y1: 69.1048,
    x2: 1242.68,
    y2: -548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_78_4792",
    x1: 121,
    y1: 82.2913,
    x2: 1254.71,
    y2: -545.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_78_4792",
    x1: 212.783,
    y1: 215.221,
    x2: 1283.89,
    y2: -394.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_78_4792",
    x1: 153.982,
    y1: 125.265,
    x2: 1278.52,
    y2: -496.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_78_4792",
    x1: 166.089,
    y1: 174.723,
    x2: 1304.24,
    y2: -455.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_78_4792",
    x1: 187.814,
    y1: 214.229,
    x2: 1309.18,
    y2: -406.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_78_4792",
    x1: 193.588,
    y1: 206.349,
    x2: 1308.82,
    y2: -411.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_78_4792",
    x1: 206.177,
    y1: 281.028,
    x2: 1345.7,
    y2: -350.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_78_4792",
    x1: 261.45,
    y1: 340.252,
    x2: 1372.25,
    y2: -275.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_78_4792",
    x1: 287.42,
    y1: 408.108,
    x2: 1395.35,
    y2: -206.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_78_4792",
    x1: 217.103,
    y1: 294.583,
    x2: 1359.59,
    y2: -338.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_78_4792",
    x1: 147.114,
    y1: 141.56,
    x2: 1269.1,
    y2: -479.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_78_4792",
    x1: 222.058,
    y1: 312.555,
    x2: 1342.55,
    y2: -307.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_78_4792",
    x1: 201.874,
    y1: 245.303,
    x2: 1319.11,
    y2: -372.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_78_4792",
    x1: 227.276,
    y1: 310.622,
    x2: 1349.25,
    y2: -310.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_78_4792",
    x1: 245.112,
    y1: 346.604,
    x2: 1366.04,
    y2: -273.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_78_4792",
    x1: 219.206,
    y1: 269.477,
    x2: 1341.19,
    y2: -351.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_78_4792",
    x1: 188.842,
    y1: 218.313,
    x2: 1315.58,
    y2: -405.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_78_4792",
    x1: 250.915,
    y1: 338.991,
    x2: 1370.26,
    y2: -280.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_78_4792",
    x1: 257.689,
    y1: 393.84,
    x2: 1380.2,
    y2: -227.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_78_4792",
    x1: 258.371,
    y1: 379.743,
    x2: 1380.36,
    y2: -241.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_78_4792",
    x1: 230.366,
    y1: 302.119,
    x2: 1352.44,
    y2: -319.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_78_4792",
    x1: 146.263,
    y1: 154.15,
    x2: 1273.51,
    y2: -469.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_78_4792",
    x1: 166.724,
    y1: 188.924,
    x2: 1288.96,
    y2: -432.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_78_4792",
    x1: 203.903,
    y1: 275.279,
    x2: 1326.72,
    y2: -345.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_78_4792",
    x1: 137.98,
    y1: 90.055,
    x2: 1252.03,
    y2: -527.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_78_4792",
    x1: 130.168,
    y1: 101.889,
    x2: 1263.82,
    y2: -525.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_78_4792",
    x1: 213.413,
    y1: 216.156,
    x2: 1283.94,
    y2: -392.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_78_4792",
    x1: 159.917,
    y1: 139.376,
    x2: 1283.91,
    y2: -482.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_78_4792",
    x1: 169.459,
    y1: 183.044,
    x2: 1307.58,
    y2: -447.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_78_4792",
    x1: 189.047,
    y1: 217.18,
    x2: 1310.97,
    y2: -403.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_78_4792",
    x1: 194.699,
    y1: 209.957,
    x2: 1309.87,
    y2: -407.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_78_4792",
    x1: 204.383,
    y1: 276.039,
    x2: 1343.64,
    y2: -355.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_78_4792",
    x1: 254.142,
    y1: 326.814,
    x2: 1364.97,
    y2: -288.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_78_4792",
    x1: 277.029,
    y1: 386.071,
    x2: 1384.96,
    y2: -228.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_78_4792",
    x1: 213.988,
    y1: 287.699,
    x2: 1356.04,
    y2: -345.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_78_4792",
    x1: 153.839,
    y1: 153.734,
    x2: 1275.29,
    y2: -466.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_78_4792",
    x1: 218.964,
    y1: 303.044,
    x2: 1340.41,
    y2: -317.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_78_4792",
    x1: 199.245,
    y1: 245.063,
    x2: 1323.33,
    y2: -376.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_78_4792",
    x1: 224.91,
    y1: 300.86,
    x2: 1343.21,
    y2: -317.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_78_4792",
    x1: 239.09,
    y1: 332.714,
    x2: 1360.55,
    y2: -287.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_78_4792",
    x1: 217.376,
    y1: 265.278,
    x2: 1338.3,
    y2: -354.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_78_4792",
    x1: 192.715,
    y1: 219.581,
    x2: 1313.55,
    y2: -400.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_78_4792",
    x1: 243.36,
    y1: 326.301,
    x2: 1365.35,
    y2: -294.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_78_4792",
    x1: 250.723,
    y1: 373.486,
    x2: 1370.49,
    y2: -245.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_78_4792",
    x1: 251.283,
    y1: 361.657,
    x2: 1371.78,
    y2: -258.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_78_4792",
    x1: 225.766,
    y1: 293.924,
    x2: 1349.34,
    y2: -327.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_78_4792",
    x1: 152.989,
    y1: 164.854,
    x2: 1279.83,
    y2: -458.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_78_4792",
    x1: 170.416,
    y1: 195.228,
    x2: 1293.45,
    y2: -426.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_78_4792",
    x1: 203.414,
    y1: 270.378,
    x2: 1325.4,
    y2: -350.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_78_4792",
    x1: 223.584,
    y1: 312.794,
    x2: 1377.25,
    y2: -294.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_78_4792",
    x1: 250.039,
    y1: 378.026,
    x2: 1402.08,
    y2: -228.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_78_4792",
    x1: 250.866,
    y1: 371.433,
    x2: 1402.71,
    y2: -235.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_78_4792",
    x1: 219.231,
    y1: 310.295,
    x2: 1372.17,
    y2: -296.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_78_4792",
    x1: 154.044,
    y1: 170.708,
    x2: 1304.25,
    y2: -434.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_78_4792",
    x1: 153.804,
    y1: 163.691,
    x2: 1305.1,
    y2: -442.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_78_4792",
    x1: 171.011,
    y1: 204.126,
    x2: 1323.39,
    y2: -403.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_78_4792",
    x1: 203.613,
    y1: 277.962,
    x2: 1355.59,
    y2: -328.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_78_4792",
    x1: 189.752,
    y1: 823.359,
    x2: 1391.89,
    y2: 823.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_78_4792",
    x1: 189.751,
    y1: 818.24,
    x2: 1391.89,
    y2: 818.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_78_4792",
    x1: 189.751,
    y1: 587.897,
    x2: 1391.89,
    y2: 587.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_78_4792",
    x1: 189.752,
    y1: 726.568,
    x2: 1391.89,
    y2: 726.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_78_4792",
    x1: 189.751,
    y1: 652.579,
    x2: 1391.89,
    y2: 652.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_78_4792",
    x1: 189.751,
    y1: 607.906,
    x2: 1391.89,
    y2: 607.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_78_4792",
    x1: 189.751,
    y1: 612.094,
    x2: 1391.89,
    y2: 612.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_78_4792",
    x1: 189.751,
    y1: 538.57,
    x2: 1391.89,
    y2: 538.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_78_4792",
    x1: 189.751,
    y1: 393.849,
    x2: 1391.89,
    y2: 393.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_78_4792",
    x1: 189.752,
    y1: 301.712,
    x2: 1391.89,
    y2: 301.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_78_4792",
    x1: 189.752,
    y1: 479.937,
    x2: 1391.89,
    y2: 479.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_78_4792",
    x1: 189.75,
    y1: 852.21,
    x2: 1391.89,
    y2: 852.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_78_4792",
    x1: 189.75,
    y1: 750.3,
    x2: 1391.89,
    y2: 750.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_78_4792",
    x1: 189.752,
    y1: 502.739,
    x2: 1391.89,
    y2: 502.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_78_4792",
    x1: 189.753,
    y1: 574.402,
    x2: 1391.89,
    y2: 574.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_78_4792",
    x1: 189.753,
    y1: 484.126,
    x2: 1391.89,
    y2: 484.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_78_4792",
    x1: 189.751,
    y1: 425.958,
    x2: 1391.89,
    y2: 425.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_78_4792",
    x1: 189.753,
    y1: 781.944,
    x2: 1391.43,
    y2: 781.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_78_4792",
    x1: 189.754,
    y1: 604.183,
    x2: 1391.89,
    y2: 604.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_78_4792",
    x1: 189.754,
    y1: 409.671,
    x2: 1391.89,
    y2: 409.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_78_4792",
    x1: 189.751,
    y1: 382.681,
    x2: 1391.89,
    y2: 382.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_78_4792",
    x1: 189.75,
    y1: 380.82,
    x2: 1391.89,
    y2: 380.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_78_4792",
    x1: 189.748,
    y1: 473.423,
    x2: 1391.89,
    y2: 473.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_78_4792",
    x1: 189.753,
    y1: 836.854,
    x2: 1391.89,
    y2: 836.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_78_4792",
    x1: 189.751,
    y1: 749.37,
    x2: 1391.89,
    y2: 749.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_78_4792",
    x1: 189.751,
    y1: 685.153,
    x2: 1391.89,
    y2: 685.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_78_4792",
    x1: 189.752,
    y1: 744.251,
    x2: 1391.89,
    y2: 744.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_78_4792",
    x1: 189.752,
    y1: 561.838,
    x2: 1391.89,
    y2: 561.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_78_4792",
    x1: 189.75,
    y1: 833.131,
    x2: 1391.89,
    y2: 833.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_78_4792",
    x1: 189.751,
    y1: 759.142,
    x2: 1391.89,
    y2: 759.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_78_4792",
    x1: 189.751,
    y1: 755.419,
    x2: 1391.89,
    y2: 755.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_78_4792",
    x1: 189.75,
    y1: 585.104,
    x2: 1391.89,
    y2: 585.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_78_4792",
    x1: 189.75,
    y1: 687.479,
    x2: 1391.89,
    y2: 687.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_78_4792",
    x1: 189.751,
    y1: 633.035,
    x2: 1391.89,
    y2: 633.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_78_4792",
    x1: 189.75,
    y1: 599.53,
    x2: 1391.89,
    y2: 599.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_78_4792",
    x1: 189.75,
    y1: 602.787,
    x2: 1391.89,
    y2: 602.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_78_4792",
    x1: 189.75,
    y1: 548.342,
    x2: 1391.89,
    y2: 548.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_78_4792",
    x1: 189.751,
    y1: 441.314,
    x2: 1391.89,
    y2: 441.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_78_4792",
    x1: 189.751,
    y1: 373.374,
    x2: 1391.89,
    y2: 373.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_78_4792",
    x1: 189.751,
    y1: 505.066,
    x2: 1391.89,
    y2: 505.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_78_4792",
    x1: 189.753,
    y1: 798.696,
    x2: 1391.89,
    y2: 798.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_78_4792",
    x1: 189.752,
    y1: 780.082,
    x2: 1391.89,
    y2: 780.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_78_4792",
    x1: 189.751,
    y1: 705.162,
    x2: 1391.89,
    y2: 705.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_78_4792",
    x1: 189.751,
    y1: 521.818,
    x2: 1391.89,
    y2: 521.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_78_4792",
    x1: 189.751,
    y1: 574.867,
    x2: 1391.89,
    y2: 574.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_78_4792",
    x1: 189.747,
    y1: 508.323,
    x2: 1391.9,
    y2: 508.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_78_4792",
    x1: 189.749,
    y1: 465.512,
    x2: 1391.89,
    y2: 465.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_78_4792",
    x1: 189.294,
    y1: 728.429,
    x2: 1391.89,
    y2: 728.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_78_4792",
    x1: 189.752,
    y1: 597.203,
    x2: 1391.43,
    y2: 597.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_78_4792",
    x1: 189.753,
    y1: 452.948,
    x2: 1391.89,
    y2: 452.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_78_4792",
    x1: 189.751,
    y1: 432.938,
    x2: 1391.89,
    y2: 432.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_78_4792",
    x1: 189.748,
    y1: 432.007,
    x2: 1391.9,
    y2: 432.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_78_4792",
    x1: 189.748,
    y1: 500.412,
    x2: 1391.89,
    y2: 500.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_78_4792",
    x1: 189.755,
    y1: 769.38,
    x2: 1391.88,
    y2: 769.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_78_4792",
    x1: 189.751,
    y1: 704.697,
    x2: 1391.89,
    y2: 704.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_78_4792",
    x1: 189.752,
    y1: 656.767,
    x2: 1391.43,
    y2: 656.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_78_4792",
    x1: 189.748,
    y1: 700.509,
    x2: 1391.89,
    y2: 700.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_78_4792",
    x1: 189.751,
    y1: 565.56,
    x2: 1391.89,
    y2: 565.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_78_4792",
    x1: 189.752,
    y1: 801.023,
    x2: 1391.89,
    y2: 801.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_78_4792",
    x1: 189.751,
    y1: 735.875,
    x2: 1391.89,
    y2: 735.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_78_4792",
    x1: 189.751,
    y1: 732.617,
    x2: 1391.89,
    y2: 732.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_78_4792",
    x1: 189.75,
    y1: 583.708,
    x2: 1391.89,
    y2: 583.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_78_4792",
    x1: 189.751,
    y1: 673.519,
    x2: 1391.89,
    y2: 673.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_78_4792",
    x1: 189.752,
    y1: 625.589,
    x2: 1391.89,
    y2: 625.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_78_4792",
    x1: 189.752,
    y1: 596.738,
    x2: 1391.89,
    y2: 596.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_78_4792",
    x1: 189.751,
    y1: 599.53,
    x2: 1391.89,
    y2: 599.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_78_4792",
    x1: 189.752,
    y1: 552.065,
    x2: 1391.89,
    y2: 552.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_78_4792",
    x1: 189.751,
    y1: 458.532,
    x2: 1391.89,
    y2: 458.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_78_4792",
    x1: 189.751,
    y1: 398.968,
    x2: 1391.89,
    y2: 398.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_78_4792",
    x1: 189.751,
    y1: 514.373,
    x2: 1391.89,
    y2: 514.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_78_4792",
    x1: 189.756,
    y1: 770.776,
    x2: 1391.43,
    y2: 770.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_78_4792",
    x1: 189.754,
    y1: 754.488,
    x2: 1391.88,
    y2: 754.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_78_4792",
    x1: 189.754,
    y1: 688.876,
    x2: 1391.88,
    y2: 688.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_78_4792",
    x1: 189.752,
    y1: 528.798,
    x2: 1391.44,
    y2: 528.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_78_4792",
    x1: 189.301,
    y1: 575.332,
    x2: 1391.88,
    y2: 575.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_78_4792",
    x1: 189.755,
    y1: 516.699,
    x2: 1391.88,
    y2: 516.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_78_4792",
    x1: 189.748,
    y1: 479.472,
    x2: 1391.9,
    y2: 479.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_78_4792",
    x1: 189.751,
    y1: 708.885,
    x2: 1391.89,
    y2: 708.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_78_4792",
    x1: 189.747,
    y1: 594.411,
    x2: 1391.89,
    y2: 594.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_78_4792",
    x1: 189.746,
    y1: 468.769,
    x2: 1391.89,
    y2: 468.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_78_4792",
    x1: 189.751,
    y1: 451.086,
    x2: 1391.89,
    y2: 451.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_78_4792",
    x1: 189.754,
    y1: 450.156,
    x2: 1391.88,
    y2: 450.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_78_4792",
    x1: 189.751,
    y1: 510.185,
    x2: 1391.89,
    y2: 510.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_78_4792",
    x1: 189.755,
    y1: 744.716,
    x2: 1391.88,
    y2: 744.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_78_4792",
    x1: 189.749,
    y1: 688.41,
    x2: 1391.9,
    y2: 688.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_78_4792",
    x1: 189.753,
    y1: 646.529,
    x2: 1391.43,
    y2: 646.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_78_4792",
    x1: 189.749,
    y1: 684.688,
    x2: 1391.44,
    y2: 684.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_78_4792",
    x1: 189.751,
    y1: 566.956,
    x2: 1391.44,
    y2: 566.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_78_4792",
    x1: 189.752,
    y1: 771.706,
    x2: 1391.89,
    y2: 771.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_78_4792",
    x1: 189.752,
    y1: 755.884,
    x2: 1391.89,
    y2: 755.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_78_4792",
    x1: 189.752,
    y1: 516.699,
    x2: 1391.89,
    y2: 516.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_78_4792",
    x1: 189.751,
    y1: 452.482,
    x2: 1391.89,
    y2: 452.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_78_4792",
    x1: 189.752,
    y1: 450.156,
    x2: 1391.89,
    y2: 450.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_78_4792",
    x1: 189.751,
    y1: 528.333,
    x2: 1391.89,
    y2: 528.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_78_4792",
    x1: 189.751,
    y1: 688.875,
    x2: 1391.89,
    y2: 688.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_78_4792",
    x1: 189.751,
    y1: 689.341,
    x2: 1391.89,
    y2: 689.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_78_4792",
    x1: 189.75,
    y1: 683.757,
    x2: 1391.89,
    y2: 683.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_78_4792",
    x1: 189.751,
    y1: 646.53,
    x2: 1391.89,
    y2: 646.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_78_4792",
    x1: 189.751,
    y1: 566.026,
    x2: 1391.89,
    y2: 566.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameSide);
export default __webpack_public_path__ + "static/media/gameSide.853de9d3c4eab642e52b408cf0356260.svg";
export { ForwardRef as ReactComponent };